  (function(){
    var MAPLIBRE_JS = window.__plkAssets.MAPLIBRE_JS;
    var MAPLIBRE_CSS = window.__plkAssets.MAPLIBRE_CSS;
    /* Phase 2: virtualized list + spatial index deps (vendored UMDs). */
    var TANSTACK_VIRTUAL_CORE_JS = window.__plkAssets.TANSTACK_VIRTUAL_CORE_JS;
    var FLATBUSH_JS = window.__plkAssets.FLATBUSH_JS;
    /* Vision-4 follow-up (Kimi QA): the map page does NOT load assets/zoom-dialog.js, so an
       injected property gallery's <zoom-dialog> never upgrades and the photo-gallery zoom throws
       ("open is not a function"). The map page already carries the importmap + component.js, so we
       can dynamically import zoom-dialog.js on demand to upgrade it. */
    var ZOOM_DIALOG_JS = window.__plkAssets.ZOOM_DIALOG_JS;
    /* D4 E8: NO pmtiles/relief — vector only. */

    var mapEl = document.getElementById('plk-map');
    var nogl = document.getElementById('plk-map-nogl');
    var panel = document.querySelector('[data-plk-panel]');

    function readJSON(id){ try { var el = document.getElementById(id); return el && el.textContent.trim() ? JSON.parse(el.textContent.trim()) : null; } catch(e){ return null; } }
    var PINS = readJSON('plk-map-pins') || [];
    var FOCUS = readJSON('plk-map-focus') || {};
    var COUNTRIES = readJSON('plk-map-countries') || [];
    var META = readJSON('plk-map-meta') || {};
    var CURATED = readJSON('plk-map-curated');

    /* Phase 2: belt-and-braces client-side parent-property filter. The server already filters
       children at bake time, but cached JSON / ?page=N fetches may lag; drop anything that looks
       like a child experience/restaurant/spa regardless of whether productType is present. */
    function isParentProperty(p){
      if (!p) return false;
      if (p.productType && ['wetu-linked-activity','wetu-linked-restaurant','wetu-linked-spa','wetu-accommodation'].indexOf(p.productType) > -1) return false;
      var cat = String(p.category || '').toLowerCase();
      if (/\b(activity|restaurant|spa|attraction|tour|site)\b/.test(cat)) return false;
      var sub = String(p.subcategory || '').toLowerCase();
      if (/\b(activity|restaurant|spa|attraction|tour|site)\b/.test(sub)) return false;
      return true;
    }
    /* 250-cap (2026-08-23 fix): gate loadMorePages() on server-baked META.pinPages
       (= paginate.pages; Shopify caps Liquid pagination at 250/page), never on the filtered
       pin count — the Phase 3a gate cut south-africa's page-1 bake to 79 (< the old
       RAW>=250 heuristic) so the map parked at 79/103 while the list hit 103 via page 2. */
    PINS = PINS.filter(isParentProperty);
    function filterPins(list){ return (list || []).filter(isParentProperty); }
    var MAP_VIEW = META.view || 'world';
    var COLLECTION_HANDLE = META.collectionHandle || '';
    var COLLECTION_TITLE = META.collectionTitle || '';
    var FRAME_KIND = META.frameKind || 'world';
    var COUNTRY_HANDLE = META.countryHandle || '';
    /* T5 Phase C: tier-driven card composition. LEVEL is baked from
       collection.metafields.plekify.dest_level (section ~187); blank on /collections/travel
       (world) and the legacy suffixed browse family. */
    var LEVEL = META.level || '';
    function tierCards(){ return LEVEL === 'country' || LEVEL === 'region' || LEVEL === 'tourism_area'; }
    function currentSlug(){ return (COLLECTION_HANDLE || '').replace(/^(country|region)-/, ''); }
    var UCOUNTRY_HANDLE = (COUNTRY_HANDLE || '').replace(/^country-/, '');  /* phase 3b: canonical nav handle; COUNTRY_HANDLE stays prefixed for geojson naming */
    /* Closing fix (item 2b): country/region frames scope semantic search to the current country. */
    var SEARCH_COUNTRY_TITLE = '';
    if (FRAME_KIND === 'country' && COLLECTION_TITLE) {
      SEARCH_COUNTRY_TITLE = COLLECTION_TITLE;
    } else if (FRAME_KIND === 'region' && UCOUNTRY_HANDLE && COUNTRIES.length) {
      for (var _ci = 0; _ci < COUNTRIES.length; _ci++) { if (COUNTRIES[_ci].handle === UCOUNTRY_HANDLE){ SEARCH_COUNTRY_TITLE = COUNTRIES[_ci].title; break; } }
    }
    var MAPS_BASE = META.mapsBase || 'https://app.plekify.com/maps/country';
    var AREAS_BASE = META.areasBase || 'https://app.plekify.com/maps/areas';
    /* Phase 3 state: active tourism area (drives pinMatchAll + crumb), the "Areas" layer toggle,
       and the hover/registry mirrors of the province machinery. */
    var activeArea = null;
    var areasOn = true;
    var hoverAreaSlug = null;
    var areaById = {};
    var COUNTRIES_URL = META.countriesUrl || 'https://app.plekify.com/maps/countries.geojson';
    var SAT_TILES = META.satTiles || '';   /* Mapbox raster satellite tiles (token baked in); '' = satellite off */

    /* Phase 2b: global pins source — "always all pins". Host-scoped to plekify (murmurgo/other stores
       keep per-collection PINS only). Fetched async; null until loaded. Fail-closed → keep PINS. */
    var PINS_GEOJSON_URL = (location.hostname.indexOf('plekify') > -1) ? (META.pinsGeojsonUrl || 'https://app.plekify.com/maps/pins.geojson') : '';
    var GLOBAL_PINS = null;
    function findPin(handle){ return (GLOBAL_PINS && GLOBAL_PINS.filter(function(p){ return p.handle === handle; })[0]) || PINS.filter(function(p){ return p.handle === handle; })[0] || null; }

    /* Phase 2a: live-backed destination hierarchy (country/region child destinations). Host-gated to
       plekify; other stores keep the previous pin-grouping fallback. The JSON is keyed by ISO code. */
    var DESTS_URL = (location.hostname.indexOf('plekify') > -1) ? 'https://app.plekify.com/maps/destinations.json' : '';
    var GLOBAL_DESTS = null;   /* { <iso>: { country: {...}, destinations: [...] } } */

    /* FOCUS: prefer server-baked handle; fall back to live ?focus= (?view= page_cache may bake a no-focus copy). */
    var focusHandle = (FOCUS && FOCUS.handle) ? FOCUS.handle : (function(){ try { return new URL(location.href).searchParams.get('focus') || ''; } catch(e){ return ''; } })();
    var focusPin = focusHandle ? findPin(focusHandle) : null;

    /* doc 203 Phase 2 URL contract v1 (.scratch/theme-dest-lane/url-contract-v1.md):
       zoom=property|region frames focus=. property (default, back-compat) = center +
       auto-open detail (z>=13); region = center at area scale z10, NO detail card.
       Read from the LIVE URL only — the server bake is path-keyed/param-blind (same
       reasoning as featuredParam below). zoom without a resolvable focus is a no-op. */
    var ZOOM_REGION = false;
    try { ZOOM_REGION = (new URL(location.href).searchParams.get('zoom') === 'region'); } catch(e){}
    var REGION_FOCUS_ZOOM = 10;

    /* 2026-08-12 (contract featured-map-mode Part B, B4a): FEATURED mode = Google-Maps "place" view.
       The transient popup sheet is promoted to a PERSISTENT full-height left rail (CSS below scopes
       off [data-featured="true"]); browse chrome (panel/search/chips/native grid) is suppressed; the
       map fills the rest. Opt-in via ?featured=1&focus=<handle> — baked server-side into META.featured
       (only when the focus product resolves). The card auto-opens through the existing focusPin ->
       selectPin -> openDetail chain (B3.1); other pins keep rendering faintly (B3.2). */
    /* Mirrors the focusHandle pattern above: the origin page_cache may bake a non-featured copy
       (path-keyed, param-blind) — fall back to the LIVE ?featured=1 param when the bake says no. */
    var featuredParam = (function(){ try { return new URL(location.href).searchParams.get('featured') === '1'; } catch(e){ return false; } })();
    var FEATURED = (!!META.featured || featuredParam) && !!focusPin;

    /* P3 + Phase 2d: persistent "Show pins" toggle (sessionStorage). Default ON for all views
       (founder: "always show all pins no matter which view you land on"); user can toggle off. */
    var PINS_KEY = 'plk_om_showpins';
    var showPins;
    try { var ss = sessionStorage.getItem(PINS_KEY); showPins = (ss === null) ? true : (ss === '1'); } catch(e){ showPins = true; }
    var Z_GATE = 12;            /* province polygons render below this zoom; pins always render when Show-pins is on (default) */

    function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]; }); }
    function norm(s){ return String(s==null?'':s).toLowerCase().trim(); }
    function round(n, d){ var f = Math.pow(10, d||2); return Math.round(n * f) / f; }

    /* ---------- WebGL probe ---------- */
    function isWebglSupported(){
      if (!window.WebGLRenderingContext) return false;
      var c = document.createElement('canvas');
      try { return !!(window.WebGLRenderingContext && (c.getContext('webgl') || c.getContext('experimental-webgl'))); }
      catch(e){ return false; }
    }
    function showFallback(){ if(mapEl) mapEl.style.display='none'; if(nogl) nogl.hidden=false; }

    /* ---------- Phase 1: map-native search (geography autocomplete + properties) + hamburger drawer ---------- */
    var searchBox = document.querySelector('[data-plk-search]');
    var sField = searchBox ? searchBox.querySelector('[data-plk-search-field]') : null;
    var sSuggest = searchBox ? searchBox.querySelector('[data-plk-suggest]') : null;
    var sClear = searchBox ? searchBox.querySelector('[data-plk-search-clear]') : null;
    var leaderOverlay = document.querySelector('.plk-leader-overlay');
    var leaderHalo = leaderOverlay ? leaderOverlay.querySelector('.plk-leader-halo') : null;
    var leaderPath = leaderOverlay ? leaderOverlay.querySelector('.plk-leader-path') : null;
    var leaderDot = leaderOverlay ? leaderOverlay.querySelector('.plk-leader-dot') : null;
    var leaderTarget = null, leaderTicking = false, leaderActive = false, leaderSavedValue = '';
    function clamp(v,a,b){ return Math.min(Math.max(v,a),b); }
    var drawer = document.querySelector('[data-plk-drawer]');
    var scrim = document.querySelector('[data-plk-scrim]');
    var azEl = document.querySelector('[data-plk-az]');
    /* ---------- hamburger drawer + A-Z country index (relocated travel-az-index) ---------- */
    function buildAZ(){
      if (!azEl) return;
      var list = COUNTRIES.slice().sort(function(a,b){ var x=norm(a.title), y=norm(b.title); return x<y?-1:(x>y?1:0); });
      var skip = { 'country-united-states-of-america':1, 'country-myanmar-burma':1 };
      var byLetter = {}, letters = [];
      list.forEach(function(c){ if (skip[c.handle]) return; var L = (c.title || '').charAt(0).toUpperCase(); if (!L) return; if (!byLetter[L]){ byLetter[L] = []; letters.push(L); } byLetter[L].push(c); });
      letters.sort();
      var html = '';
      letters.forEach(function(L){
        html += '<div class="plk-drawer__azrow"><div class="plk-drawer__azletter">'+L+'</div><div>';
        byLetter[L].forEach(function(c){ html += '<a class="plk-drawer__azlink" href="/collections/'+esc(c.handle)+'">'+esc(c.title)+(c.count?'<span class="plk-drawer__azcount">'+c.count+'</span>':'')+'</a>'; });
        html += '</div></div>';
      });
      azEl.innerHTML = html;
    }
    function openDrawer(){ if (drawer){ drawer.setAttribute('data-open','true'); drawer.setAttribute('aria-hidden','false'); } if (scrim) scrim.setAttribute('data-open','true'); if (azEl && !azEl.childNodes.length) buildAZ(); }
    function closeDrawer(){ if (drawer){ drawer.setAttribute('data-open','false'); drawer.setAttribute('aria-hidden','true'); } if (scrim) scrim.setAttribute('data-open','false'); }
    var burgers = document.querySelectorAll('[data-plk-burger]');
    var dClose = document.querySelector('[data-plk-drawer-close]');
    burgers.forEach(function(btn){ btn.addEventListener('click', openDrawer); });
    if (dClose) dClose.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') closeDrawer(); });
    /* Eager-build A–Z so the drawer is never empty, even if opened programmatically. */
    if (azEl && FRAME_KIND === 'world') buildAZ();

    /* ---------- country resolution + bbox helpers (mirror travel-map-anchor) ---------- */
    var NAME_FIELDS = ['name','name_long','name_sort','admin','name_ciawf','formal_en','sovereign','geounit','subunit'];
    var nameIndex = {}, handleByIso3 = {}, handleForIso3 = {}, titleForIso3 = {}, featByIso3 = {}, activeCountryIso3 = '';
    function bindCountries(features){
      (features||[]).forEach(function(ft){
        var p = ft.properties || {}; var iso3 = p.iso3; if(!iso3) return;
        NAME_FIELDS.forEach(function(k){ var v = p[k]; if(v) nameIndex[norm(v)] = iso3; });
        featByIso3[iso3] = ft;
      });
      COUNTRIES.forEach(function(c){
        var iso3 = nameIndex[norm(c.title)];
        if(iso3){ handleByIso3[c.handle] = iso3; handleForIso3[iso3] = c.handle; titleForIso3[iso3] = c.title; if(window._plkMap) window._plkMap.setFeatureState({source:'countries', id:iso3}, {live:true}); }
      });
      var cTitle = COLLECTION_TITLE;
      if (FRAME_KIND === 'region' && UCOUNTRY_HANDLE){ for (var i=0;i<COUNTRIES.length;i++){ if (COUNTRIES[i].handle === UCOUNTRY_HANDLE){ cTitle = COUNTRIES[i].title; break; } } }
      if(cTitle){ var ci = nameIndex[norm(cTitle)]; if(ci){ activeCountryIso3 = ci; if(window._plkMap){ window._plkMap.setFeatureState({source:'countries', id:ci}, {live:true}); } } }
    }
    function fcBbox(ft){
      /* Africa-focus 2026-07-29: bound the LARGEST polygon (the mainland), not the whole MultiPolygon —
         otherwise far-flung territories distort the bbox (e.g. South Africa + Marion Island at -47° makes
         the country frame tiny + off-fill). Largest polygon by outer-ring point count = the mainland. */
      if(!ft || !ft.geometry || !ft.geometry.coordinates) return null;
      var polys = ft.geometry.type === 'Polygon' ? [ft.geometry.coordinates] : ft.geometry.coordinates;
      var best = null, bestN = -1;
      polys.forEach(function(poly){ var ring = (poly && poly[0]) || []; if(ring.length > bestN){ bestN = ring.length; best = ring; } });
      if(!best || !best.length) return null;
      var xs=[], ys=[]; best.forEach(function(c){ xs.push(c[0]); ys.push(c[1]); });
      return [Math.min.apply(null,xs), Math.min.apply(null,ys), Math.max.apply(null,xs), Math.max.apply(null,ys)];
    }
    function fitBbox(bbox, pad){
      if(!bbox || bbox.length<4 || !window._plkMap) return;
      try { window._plkMap.fitBounds([[bbox[0],bbox[1]],[bbox[2],bbox[3]]], { padding: (typeof pad==='number'?pad:pad||40), linear:false }); } catch(e){}
    }
    function padLeft(){
      var iw = window.innerWidth;
      if (iw < 750) return { top: 120, bottom: 90, left: 60, right: 60 };
      var left = 408 + 24;              /* full-height left column + gap */
      if (sheetOpen) left += 408 + 16;  /* + detail panel + right pad when a property is open */
      return { top: 120, bottom: 90, left: left, right: 70 };
    }
    function padFrame(){
      /* Africa-focus 2026-07-29: frame the country into the ACTUAL visible map rectangle. The embedded
         country/region page has a ~32px top header over the map + a docked grid on the left. To center the
         country in the VISIBLE area (not the full canvas), top padding = header(32) + margin, bottom = margin,
         so the margins are equal within the visible band → vertically centered. Left = measured grid right. */
      var iw = window.innerWidth, ih = window.innerHeight;
      var leftOcclude = 0;
      var grid = document.querySelector('[plk-embedded-grid], .plk-mapmode__list, .product-grid');
      if (grid){ var gr = grid.getBoundingClientRect(); if (gr.width > 0 && gr.right > 0 && gr.right < iw) leftOcclude = gr.right; }
      if (iw < 750) {
        return { top: 96, bottom: 80, left: 28, right: 28 };
      }
      return { top: 120, bottom: 100, left: Math.max(leftOcclude + 80, 488), right: 80 };
    }

    /* ---------- GEOJSON pins source (unclustered) ---------- */
    function pinsToFeatures(list){
      list = list || PINS;
      return { type:'FeatureCollection', features: list.map(function(p){
        return { type:'Feature', geometry:{ type:'Point', coordinates:[p.lon, p.lat] }, properties: {
          handle:p.handle, title:p.title, url:p.url, lat:p.lat, lon:p.lon, image:p.image, category:p.category,
          country:p.country, countryHandle:p.countryHandle, region:p.region, regionHandle:p.regionHandle,
          area:p.area, rooms:p.rooms, interests:p.interests, copyShort:p.copyShort, copyMedium:p.copyMedium } };
      }) };
    }
    function inBounds(p, b){ return p.lon >= b.getWest() && p.lon <= b.getEast() && p.lat >= b.getSouth() && p.lat <= b.getNorth(); }

    /* Phase 2: spatial index + filtered base set. The index is built over the chip-filtered base;
       areaFilter queries the index (or falls back to inBounds). Rebuild only on chip/base change,
       never on pan. */
    var basePins = PINS.slice();
    var pinIndex = null;
    function rebuildBasePins(){
      basePins = (activeChip || activeRegion || activeArea) ? PINS.filter(pinMatchAll) : PINS.slice();
      rebuildPinIndex();
    }
    function rebuildPinIndex(){
      if (!window.Flatbush) { pinIndex = null; return; }
      var mappable = basePins.filter(function(p){ return p.lon != null && p.lat != null; });
      try {
        var idx = new window.Flatbush(Math.max(1, mappable.length));
        mappable.forEach(function(p){ idx.add(p.lon, p.lat, p.lon, p.lat); });
        idx.finish();
        pinIndex = { idx: idx, pins: mappable };
      } catch(e) { pinIndex = null; if (window.console) console.warn('[plk-map] pin index build failed:', e); }
    }
    function effectivePins(){
      var list;
      if (!areaFilter) { list = basePins; }
      else if (pinIndex) {
        try {
          var ids = pinIndex.idx.search(areaFilter.getWest(), areaFilter.getSouth(), areaFilter.getEast(), areaFilter.getNorth());
          list = ids.map(function(i){ return pinIndex.pins[i]; });
        } catch(e) {}
      }
      if (!list) list = basePins.filter(function(p){ return inBounds(p, areaFilter); });
      return sortPins(list);
    }
    /* Phase 2d: client-side sort of the effective list. featured = flagshipScore desc (the map's
       default order); az = title asc; region = grouped by region (blank last), then flagship desc.
       Always returns a COPY — never mutates basePins or the spatial-index array. */
    function sortPins(list){
      if (!list || !list.length) return list;
      var m = (SORT_MODES.indexOf(sortMode) > -1) ? sortMode : 'featured';
      var out = list.slice();
      out.sort(function(a, b){
        var fa = Number(a.flagshipScore) || 0, fb = Number(b.flagshipScore) || 0;
        if (m === 'az') {
          var x = norm(a.title), y = norm(b.title);
          if (x !== y) return x < y ? -1 : 1;
          return fb - fa;
        }
        /* Phase 2e: native sort translations — title desc (zd), price asc/desc (pa/pd) over the
           baked pins (a fallback key keeps order stable for equal values). */
        if (m === 'zd') {
          var x = norm(a.title), y = norm(b.title);
          if (x !== y) return x > y ? -1 : 1;
          return fb - fa;
        }
        if (m === 'pa' || m === 'pd') {
          var _od = (m === 'pa') ? 1 : -1;
          var pa = Number(a.price) || 0, pb = Number(b.price) || 0;
          if (pa !== pb) return (pa - pb) * _od;
          return fb - fa;
        }
        if (m === 'region') {
          var ar = norm(a.region), br = norm(b.region);
          if (ar && !br) return -1;
          if (!ar && br) return 1;
          if (ar !== br) return ar < br ? -1 : 1;
          return fb - fa;
        }
        return fb - fa;
      });
      return out;
    }

    /* Phase 2b: map the global GeoJSON features to the same pin-object shape pinsToFeatures expects
       (derive url from handle; country/region display names fall back to handles; rooms/interests/copyMedium
       are not in the 11-field export → empty). Keeps pin-click/popup/sheet handlers working unchanged. */
    function geojsonToPins(fc){
      if (!fc || !fc.features) return [];
      return fc.features.map(function(f){
        var p = (f && f.properties) || {};
        var co = (f && f.geometry && f.geometry.coordinates) || [];
        return {
          handle: p.handle || '', title: p.title || '',
          url: p.handle ? ('/products/' + p.handle) : '',
          lat: (p.lat != null) ? p.lat : co[1], lon: (p.lon != null) ? p.lon : co[0],
          image: p.image || '', category: p.category || '',
          country: p.country || '', countryHandle: p.countryHandle || '',
          region: p.region || '', regionHandle: p.regionHandle || '',
          area: p.area || '', rooms: p.rooms || [], interests: p.interests || [],
          copyShort: p.copyShort || '', copyMedium: p.copyMedium || ''
        };
      });
    }
    function fetchGlobalPins(){
      if (!PINS_GEOJSON_URL) return;
      fetch(PINS_GEOJSON_URL, { headers: { 'Accept': 'application/geo+json' } })
        .then(function(r){ if (!r.ok) throw new Error('pins.geojson HTTP ' + r.status); return r.json(); })
        .then(function(fc){
          GLOBAL_PINS = filterPins(geojsonToPins(fc));
          refreshSource();
          /* Re-resolve the focused pin against the now-loaded runtime coords and re-center if the
             initial framing used stale baked PINS. Guarded by selectedMarker so we don't reopen a
             sheet the user has already closed. */
          if (focusHandle && selectedMarker && map && map.getSource('pins')) {
            var newFocus = findPin(focusHandle);
            if (newFocus) {
              var needRecenter = !focusPin || focusPin.lat !== newFocus.lat || focusPin.lon !== newFocus.lon;
              focusPin = newFocus;
              if (needRecenter) selectPin(focusPin.handle, {silent:true});
            }
          }
        })
        .catch(function(e){ /* fail-closed: keep per-collection PINS */ if (window.console) console.warn('[plk-map] global pins fetch failed, using per-collection pins:', e && e.message); });
    }

    /* Phase 2a: fetch the live destination hierarchy. Fail-closed -> keep the pin-grouping fallback. */
    function fetchDestinations(){
      if (!DESTS_URL) return;
      fetch(DESTS_URL, { headers: { 'Accept': 'application/json' } })
        .then(function(r){ if (!r.ok) throw new Error('destinations.json HTTP ' + r.status); return r.json(); })
        .then(function(data){
          GLOBAL_DESTS = data;
          rebuildDests();
          if (map) refreshDestSource();
          updateHierarchyRail();
          /* T5 Phase C: a card tier with NO children falls back to property rows (the
             country==region fix — the branch is children-presence, not the level alone). */
          if (autoDestDefault && listType === 'destinations' && !DESTS.length){ setListType('properties', {silent:true}); }
        })
        .catch(function(e){ if (window.console) console.warn('[plk-map] destinations.json fetch failed, using pin-grouping:', e && e.message); if (autoDestDefault && listType === 'destinations') setListType('properties', {silent:true}); });
    }

    function refreshSource(){
      if (!(map && map.getSource('pins'))) return;
      try {
        var list;
        if (MAP_VIEW === 'world' && GLOBAL_PINS && GLOBAL_PINS.length) {
          list = activeChip ? GLOBAL_PINS.filter(pinChipMatch) : GLOBAL_PINS;
          if (areaFilter) list = list.filter(function(p){ return inBounds(p, areaFilter); });
        } else {
          list = currentPins();
        }
        map.getSource('pins').setData(pinsToFeatures(list));
      } catch(e){}
    }

    /* ---------- Phase 2: filter chips + geography-aware overview pane + mode switching ---------- */
    var chipsEl = document.querySelector('[data-plk-chips]');
    /* T5 Phase C: hierarchy chip rail (destinations.json children). Rendered + visibility-driven
       from updateHierarchyRail(); hidden on leaf tiers (city/suburb), featured mode and world. */
    var hRailEl = document.querySelector('[data-plk-hrail]');
    var hRailInner = hRailEl ? hRailEl.querySelector('[data-plk-hrail-inner]') : null;
    var hRailLabel = hRailEl ? hRailEl.querySelector('[data-plk-hrail-label]') : null;
    /* Phase 1: move the search box + chips bar into the panel's fixed header so the list body is a
       clean flex:1 scrollable area below a fixed header zone. Search stays viewport-fixed on mobile. */
    var fixedHeader = panel ? panel.querySelector('[data-plk-panel-fixed]') : null;
    function dockPanelHeader(){
      if (!fixedHeader) return;
      var isDesktop = window.innerWidth >= 750;
      if (chipsEl && chipsEl.parentNode !== fixedHeader) fixedHeader.appendChild(chipsEl);
      if (searchBox) {
        if (isDesktop) {
          if (searchBox.parentNode !== fixedHeader) fixedHeader.insertBefore(searchBox, fixedHeader.firstChild);
        } else {
          var root = document.querySelector('[data-plk-mapmode]');
          if (root && searchBox.parentNode !== root) root.insertBefore(searchBox, root.firstChild);
        }
      }
    }
    if (fixedHeader) { dockPanelHeader(); window.addEventListener('resize', dockPanelHeader); }
    var overviewEl = document.querySelector('[data-plk-overview]');
    var clearBtn = panel ? panel.querySelector('[data-plk-clear]') : null;
    /* Phase 2d: region + sort controls (the filters row in the panel fixed header). */
    var filtersEl = document.querySelector('[data-plk-filters]');
    var regionSelect = filtersEl ? filtersEl.querySelector('[data-plk-region]') : null;
    var sortSelect = filtersEl ? filtersEl.querySelector('[data-plk-sort]') : null;
    var lastListMode = 'overview';
    var activeChip = null;   /* a CHIP_DEFS label, or null */
    /* Phase 2d: region facet + sort — client-side only, from the baked PINS. */
    var SORT_MODES = ['featured', 'az', 'zd', 'pa', 'pd', 'region'];
    var activeRegion = null;   /* a pin.region display name, or null */
    var sortMode = 'featured'; /* featured (flagshipScore desc) | az/zd (title asc/desc) | pa/pd (price asc/desc) | region (grouped) */

    function pinTags(p){ var t = []; [p.category, p.subcategory].forEach(function(x){ if (x) t.push(norm(x)); }); (p.interests||[]).forEach(function(x){ if (x) t.push(norm(x)); }); return t; }
    /* Map chip labels -> category/interest keywords (lowercased) that a pin must match. */
    var CHIP_DEFS = [
      { label:'Hotels', kw:['hotel','boutique hotel'] },
      { label:'Lodges', kw:['lodge','safari lodge','tented camp'] },
      { label:'Resorts', kw:['resort'] },
      { label:'Guest houses', kw:['guest house','guesthouse','bed and breakfast','b & b','breakfast'] },
      { label:'Self-catering', kw:['self catering','self-catering'] },
      { label:'Villas & Apts', kw:['villa','apartment','condo'] },
      { label:'Safari camps', kw:['camp','campsite','safari camp','mobile safari'] },
      { label:'Things to do', kw:['activity','activities','attraction','site attraction','things to do','tour'] },
      { label:'Restaurants', kw:['restaurant','dining','eatery'] },
      { label:'Beaches', kw:['beach'] },
      { label:'Wellness', kw:['spa','wellness'] }
    ];
    function chipMatch(pin, def){ var tags = pin.__tags || (pin.__tags = pinTags(pin)); for (var i=0;i<def.kw.length;i++){ if (tags.indexOf(def.kw[i]) > -1) return true; } return false; }
    function pinChipMatch(pin){ if (!activeChip) return true; var def = null; for (var i=0;i<CHIP_DEFS.length;i++){ if (CHIP_DEFS[i].label === activeChip){ def = CHIP_DEFS[i]; break; } } return def ? chipMatch(pin, def) : true; }
    /* Phase 2d: the region facet AND-combines with the active property-type chip through the same
       rebuildBasePins/effectivePins path (the area viewport filter stays applied on top). */
    /* Phase 2d fix: compare normalized-to-normalized — activeRegion carries the raw display name
       ("Western Cape") from the dropdown/deep-link, so the old pin.region-vs-raw test never matched. */
    function regionMatch(pin){ if (!activeRegion) return true; return norm(pin.region) === norm(activeRegion); }
    function areaMatch(pin){ if(!activeArea) return true; return !!activeArea.members[pin.handle]; }
    function pinMatchAll(pin){ return pinChipMatch(pin) && regionMatch(pin) && areaMatch(pin); }
    function currentPins(){ return effectivePins(); }
    function countForChip(def){ var n = 0; var base = areaFilter ? PINS.filter(function(p){ return inBounds(p, areaFilter); }) : PINS; for (var i=0;i<base.length;i++){ if (chipMatch(base[i], def)) n++; } return n; }

    function setMode(m){ if (!panel) return; if (m !== 'detail' && m !== 'overview' && m !== 'results') return; if (m !== 'detail') lastListMode = m; panel.setAttribute('data-mode', m); }

    /* T5 Phase C: hierarchy chip rail = direct children of the current destination
       (childrenBySlug[current] — destinations.json parent_slug, NOT product facets).
       Visible only on card tiers (country/region/tourism_area) with children — the same
       children-presence branch that drives place-cards; hidden on leaf tiers (city/suburb),
       featured mode and world. Click = the standard drill (selectDestination). */
    function updateHierarchyRail(){
      if (!hRailEl || !hRailInner) return;
      var kids = childrenBySlug[currentSlug()] || [];
      var show = !FEATURED && MAP_VIEW === 'collection' && tierCards() && kids.length > 0;
      hRailEl.hidden = !show;
      if (!show) return;
      if (hRailLabel) hRailLabel.textContent = (LEVEL === 'country') ? 'Regions within' : 'Places within';
      hRailInner.innerHTML = kids.map(function(c){
        return '<button class="plk-hrail__chip" type="button" role="listitem" data-hrail-slug="'+cssEsc(c.slug)+'">'+esc(c.name)+'</button>';
      }).join('');
      hRailInner.querySelectorAll('.plk-hrail__chip').forEach(function(b){
        b.addEventListener('click', function(){ var s = b.getAttribute('data-hrail-slug'); if (s) selectDestination(s); });
      });
    }

    function buildChips(){
      /* Phase 2d: reveal the region/sort row alongside the chips (CSS hides it for world view +
         destinations mode; the [hidden] attr just suppresses the pre-JS flash). */
      if (filtersEl) filtersEl.hidden = false;
      buildRegionOptions();
      if (!chipsEl || MAP_VIEW !== 'collection' || !PINS.length){ if (chipsEl) chipsEl.hidden = true; if (panel) panel.classList.remove('plk-panel--withchips'); return; }
      var html = '';
      CHIP_DEFS.forEach(function(d){ if (countForChip(d) > 0){ html += '<button class="plk-chip" type="button" role="tab" data-chip="'+esc(d.label)+'" data-active="false">'+esc(d.label)+'</button>'; } });
      if (!html){ chipsEl.hidden = true; if (panel) panel.classList.remove('plk-panel--withchips'); return; }
      chipsEl.innerHTML = html; chipsEl.hidden = false; if (panel) panel.classList.add('plk-panel--withchips');
      chipsEl.querySelectorAll('.plk-chip').forEach(function(c){ c.addEventListener('click', function(){ selectChip(c.getAttribute('data-chip')); }); });
    }
    /* Phase 2d — region facet + sort. Region options + counts come from the baked PINS, using the
       same base countForChip uses (the viewport-filtered set), so counts reflect the visible area.
       Selecting a region AND-combines through rebuildBasePins/effectivePins — the SAME flow the
       type chips use — so the list + map pins update together. Both are persisted in the URL
       (?region=<name>&sort=az|region|featured) via history.replaceState for deep-linking. */
    function buildRegionOptions(){
      if (!regionSelect) return;
      var base = areaFilter ? PINS.filter(function(p){ return inBounds(p, areaFilter); }) : PINS;
      var counts = {}, order = [];
      for (var i = 0; i < base.length; i++){
        var p = base[i];
        if (!p || !p.region) continue;
        var nm = norm(p.region);
        if (!nm) continue;
        if (!counts[nm]){ counts[nm] = { name: String(p.region), n: 0 }; order.push(nm); }
        counts[nm].n++;
      }
      order.sort(function(a, b){ return (counts[b].n - counts[a].n) || (counts[a].name < counts[b].name ? -1 : 1); });
      var html = '<option value="">All regions</option>';
      for (var k = 0; k < order.length; k++){ html += '<option value="'+esc(counts[order[k]].name)+'">'+esc(counts[order[k]].name)+' ('+counts[order[k]].n+')</option>'; }
      regionSelect.innerHTML = html;
      regionSelect.value = activeRegion || '';
    }
    function selectRegion(name){
      activeRegion = name || null;
      if (regionSelect) regionSelect.value = activeRegion || '';
      setRegionUrl(activeRegion);
      showClearIfActive();
      rebuildBasePins(); setListType('properties'); resetListScroll(); refreshSource(); applyGate();
    }
    function applySort(mode){
      if (SORT_MODES.indexOf(mode) < 0) mode = 'featured';
      sortMode = mode;
      if (sortSelect) sortSelect.value = mode;
      syncNativeSort(mode);
      setSortUrl(mode);
      showClearIfActive();
      rebuildBasePins(); setListType('properties'); resetListScroll(); refreshSource(); applyGate();
    }
    function showClearIfActive(){ if (clearBtn) clearBtn.hidden = !(activeChip || activeRegion || areaFilter || activeArea || sortMode !== 'featured'); }
    function setRegionUrl(name){ try { var u = new URL(location.href); if (name){ u.searchParams.set('region', name); } else { u.searchParams.delete('region'); } history.replaceState(null, '', u.href); } catch(e){} }
    function setSortUrl(mode){ try { var u = new URL(location.href); if (mode && mode !== 'featured'){ u.searchParams.set('sort', mode); } else { u.searchParams.delete('sort'); } history.replaceState(null, '', u.href); } catch(e){} }
    function regionFromUrl(){ try { return new URL(location.href).searchParams.get('region'); } catch(e){ return null; } }
    function sortFromUrl(){ try { var s = new URL(location.href).searchParams.get('sort'); return (s && SORT_MODES.indexOf(s) > -1) ? s : null; } catch(e){ return null; } }
    function sortByFromUrl(){ try { var sb = new URL(location.href).searchParams.get('sort_by'); return (sb && sb !== 'relevance') ? sb : null; } catch(e){ return null; } }
    function regionNameFromUrl(){ var raw = regionFromUrl(); if (!raw) return ''; var n = norm(raw); for (var i = 0; i < PINS.length; i++){ if (norm(PINS[i].region) === n) return String(PINS[i].region); } return ''; }
    if (regionSelect){ regionSelect.addEventListener('change', function(){ selectRegion(regionSelect.value || null); }); }
    if (sortSelect){ sortSelect.addEventListener('change', function(){ applySort(sortSelect.value); }); }
    /* Phase 2e: native sort select (grid-parity options). VERIFIED mechanism: this shop's bake does
       NOT re-order under ?sort_by= — Shopify mirrors the param into collection.sort_by (the select's
       Liquid-selected state proves it) but collections[handle].products keeps its base order in the
       custom section. So the select translates to a client-side sort over the baked pins (no reload —
       camera, region, list scroll all stay put) and mirrors ?sort_by= into the URL for shareability. */
    var SORTBY_TO_MODE = { 'manual':'featured', 'best-selling':'featured', 'title-ascending':'az', 'title-descending':'zd', 'price-ascending':'pa', 'price-descending':'pd' };
    var MODE_TO_SORTBY = { 'featured':'manual', 'az':'title-ascending', 'zd':'title-descending', 'pa':'price-ascending', 'pd':'price-descending' };
    /* Phase 2f: the native sort is rendered by the theme's sorting snippet. Query its
       select inside the filter bar and translate the chosen Shopify sort_by into our client sort mode. */
    var nativeSort = filtersEl ? filtersEl.querySelector('.sorting-filter__select') : null;
    if (nativeSort){
      nativeSort.addEventListener('change', function(){
        applySort(SORTBY_TO_MODE[nativeSort.value] || 'featured');
        try {
          var u = new URL(location.href);
          if (nativeSort.value) u.searchParams.set('sort_by', nativeSort.value); else u.searchParams.delete('sort_by');
          history.replaceState(null, '', u.href);
        } catch(e){}
      });
    }
    function syncNativeSort(mode){
      if (!nativeSort) return;
      var sb = MODE_TO_SORTBY[mode] || 'manual';
      if (nativeSort.value !== sb) nativeSort.value = sb;
    }
    function selectChip(label){
      activeChip = (activeChip === label) ? null : label;
      if (chipsEl){ chipsEl.querySelectorAll('.plk-chip').forEach(function(c){ c.setAttribute('data-active', c.getAttribute('data-chip') === activeChip ? 'true' : 'false'); }); }
      setCategoryUrl(activeChip);
      if (activeChip){ showPins = true; try{ sessionStorage.setItem(PINS_KEY, '1'); }catch(_){} }
      showClearIfActive();   /* Phase 2d: a region facet or non-default sort can keep the Clear visible too */
      rebuildBasePins();   /* Phase 2: chip changes the base set; areaFilter stays applied to new base. */
      setListType('properties'); resetListScroll();   /* doc 106: chips are property-category filters -> properties mode (renders rows + swaps map layers) */
      refreshSource(); applyGate();
    }
    function clearAllFilters(){
      activeChip = null; areaFilter = null; activeRegion = null; sortMode = 'featured';
      activeArea = null;   /* Phase 3: area drill-down is part of the Clear reset */
      var _crumb = document.querySelector('[data-plk-areacrumb]'); if(_crumb){ _crumb.hidden = true; }
      if (chipsEl){ chipsEl.querySelectorAll('.plk-chip').forEach(function(c){ c.setAttribute('data-active','false'); }); }
      if (regionSelect) regionSelect.value = '';
      if (sortSelect) sortSelect.value = 'featured';
      /* Phase 2e: drop an active native ?sort_by= (client-side — sortMode 'featured' re-orders the
         view; the stale ?sort_by= is cleared from the URL so a refresh/navigation restarts clean). */
      if (nativeSort){ nativeSort.value = 'manual'; try { var _u = new URL(location.href); _u.searchParams.delete('sort_by'); history.replaceState(null,'',_u.href); } catch(e){} }
      setCategoryUrl(null); setRegionUrl(null); setSortUrl(null);
      rebuildBasePins();   /* Phase 2: return to full parent set. */
      setListType('properties'); resetListScroll(); refreshSource(); applyGate();
      buildRegionOptions();
      if (searchBtn) searchBtn.setAttribute('data-show','false');
      if (clearBtn) clearBtn.hidden = true;
    }
    function setCategoryUrl(label){ try { var u = new URL(location.href); if (label){ u.searchParams.set('category', label); } else { u.searchParams.delete('category'); } history.replaceState(null,'',u.href); } catch(e){} }
    function categoryFromUrl(){ try { return new URL(location.href).searchParams.get('category') || null; } catch(e){ return null; } }

    /* ---------- Phase 5: shared breadcrumb component (world/country/region + popup) ---------- */
    function findCountryByHandle(handle){
      if (!handle) return null;
      for (var i = 0; i < COUNTRIES.length; i++){ if (COUNTRIES[i].handle === handle) return COUNTRIES[i]; }
      return null;
    }
    function renderPanelCrumb(){
      var el = panel ? panel.querySelector('[data-plk-crumb]') : null;
      if (!el) return;
      var html = '<a href="/collections/travel">Africa</a>';
      if (FRAME_KIND === 'country'){
        html += '<span>›</span><b>'+esc(COLLECTION_TITLE)+'</b>';
      } else if (FRAME_KIND === 'region'){
        var country = findCountryByHandle(UCOUNTRY_HANDLE);
        if (country && country.handle && country.title){
          html += '<span>›</span><a href="/collections/'+cssEsc(country.handle)+'">'+esc(country.title)+'</a>';
        }
        html += '<span>›</span><b>'+esc(COLLECTION_TITLE)+'</b>';
      }
      el.innerHTML = html;
    }
    function renderWorldCrumb(){
      var el = document.querySelector('[data-plk-world-crumb]');
      if (!el) return;
      el.innerHTML = '<a href="/collections/travel">Africa</a>';
    }
    function renderSheetCrumb(pin){
      var el = sheetEl ? sheetEl.querySelector('[data-plk-sheet-crumb]') : null;
      if (!el) return;
      var html = '<a href="/collections/travel">Africa</a>';
      var countryHandle = (pin && pin.countryHandle) || (FRAME_KIND === 'country' ? COLLECTION_HANDLE : (FRAME_KIND === 'region' ? UCOUNTRY_HANDLE : ''));
      var countryTitle = (pin && pin.country) || '';
      if (!countryTitle && FRAME_KIND === 'country'){ countryTitle = COLLECTION_TITLE; }
      if (!countryTitle && FRAME_KIND === 'region'){ var c = findCountryByHandle(UCOUNTRY_HANDLE); if (c) countryTitle = c.title; }
      var regionHandle = (pin && pin.regionHandle) || (FRAME_KIND === 'region' ? COLLECTION_HANDLE : '');
      var regionTitle = (pin && pin.region) || (FRAME_KIND === 'region' ? COLLECTION_TITLE : '');
      if (countryHandle && countryTitle){
        html += '<span>›</span><a href="/collections/'+cssEsc(countryHandle)+'">'+esc(countryTitle)+'</a>';
      }
      if (regionHandle && regionTitle){
        html += '<span>›</span><a href="/collections/'+cssEsc(regionHandle)+'">'+esc(regionTitle)+'</a>';
      }
      if (pin && pin.title){
        html += '<span>›</span><b>'+esc(pin.title)+'</b>';
      }
      el.innerHTML = html;
    }

    /* ---------- overview pane (world = country list; country/region = header + carousels) ---------- */
    function carouselHtml(title, pins){
      if (!pins || !pins.length) return '';
      var cards = pins.slice(0, 12).map(function(p){
        var media = p.image ? '<img src="'+esc(p.image)+'" alt="" loading="lazy">' : '<div class="plk-ov__ph">&#x25CF;</div>';
        var place = [p.area, p.region, p.country].filter(Boolean).slice(0,2).join(', ');
        return '<button class="plk-ov__card" type="button" data-handle="'+cssEsc(p.handle)+'"><div class="plk-ov__media">'+media+'</div><div class="plk-ov__name">'+esc(p.title)+'</div>'+(place?'<div class="plk-ov__place">'+esc(place)+'</div>':'')+'</button>';
      }).join('');
      return '<div class="plk-ov__sec">'+esc(title)+'</div><div class="plk-ov__rail">'+cards+'</div>';
    }
    function wireCards(root){ if (!root) return; root.querySelectorAll('.plk-ov__card').forEach(function(c){ c.addEventListener('click', function(){ selectPin(c.getAttribute('data-handle')); }); }); }
    function renderOverview(){
      renderWorldCrumb();
      if (!overviewEl) return;
      if (MAP_VIEW === 'world'){ renderWorldOverview(); return; }
      var country = null; for (var i=0;i<COUNTRIES.length;i++){ if (COUNTRIES[i].handle === COLLECTION_HANDLE){ country = COUNTRIES[i]; break; } }
      var summary = (country && (country.summaryLong || country.summary)) || '';
      var html = '<div class="plk-ov__head"><h2 class="plk-ov__title">'+esc(COLLECTION_TITLE || 'Properties')+'</h2>';
      if (PINS.length){
        var count = (country && country.count) ? country.count : PINS.length;
        html += '<p class="plk-ov__count">'+count+' propert'+(count===1?'y':'ies')+'</p>';
      } else {
        html += '<p class="plk-ov__count">No properties mapped here yet</p>';
      }
      if (summary) html += '<p class="plk-ov__summary">'+esc(summary)+'</p>';
      if (country && country.regions && country.regions.length){ html += '<div class="plk-ov__chips">'; country.regions.slice(0,12).forEach(function(r){ html += '<a class="plk-ov__chip" href="/collections/'+esc(r.handle)+'">'+esc(r.label)+'</a>'; }); html += '</div>'; }
      html += '</div>';
      renderPanelCrumb();
      if (PINS.length){
        var featured = PINS.slice().sort(function(a,b){ return (Number(b.flagshipScore)||0) - (Number(a.flagshipScore)||0); });
        html += carouselHtml('Featured stays', featured);
      } else {
        html += CURATED ? curatedBlock() : '<div class="plk-panel__empty" style="margin:8px 16px;text-align:left">No properties with a mapped location in this collection yet. Try another area, or open the <a href="/collections/'+esc(COLLECTION_HANDLE)+'">full country page</a>.</div>';
      }
      overviewEl.innerHTML = html;
      wireCards(overviewEl);
    }
    function renderWorldOverview(){
      if (!overviewEl) return;
      var sorted = COUNTRIES.slice().sort(function(a,b){ return (b.count||0)-(a.count||0); });
      var html = '<div class="plk-ov__head"><h2 class="plk-ov__title">Explore destinations</h2><p class="plk-ov__count">'+COUNTRIES.length+' countries</p>';
      html += '<p class="plk-ov__summary">Search a country or tap one on the map to begin. Pick a place from the list, or use the filters to browse stays and experiences.</p></div>';
      sorted.forEach(function(c){
        if (!c.count) return;
        var flag = c.image ? '<img class="plk-ov__flag" src="'+esc(c.image)+'" alt="">' : '<div class="plk-ov__flag" style="display:grid;place-items:center;color:#a7abb1;font-size:18px">&#x1F310;</div>';
        html += '<button class="plk-ov__country" type="button" data-handle="'+esc(c.handle)+'">'+flag+'<div class="plk-ov__cbody"><div class="plk-ov__cname">'+esc(c.title)+'</div>'+(c.summary?'<div class="plk-ov__csum">'+esc(c.summary)+'</div>':'')+'</div><span class="plk-ov__ccount">'+c.count+'</span></button>';
      });
      overviewEl.innerHTML = html;
      overviewEl.querySelectorAll('.plk-ov__country').forEach(function(b){ b.addEventListener('click', function(){ window.location.href = '/collections/'+b.getAttribute('data-handle'); }); });
    }
    if (clearBtn){ clearBtn.addEventListener('click', clearAllFilters); }

    /* ---------- Vision-2 (doc 102): expansive PDP popup (fetch+inject #MainContent) + overlay-aware pan ---------- */
    var sheetEl = document.querySelector('[data-plk-sheet]');
    var sheetBody = sheetEl ? sheetEl.querySelector('[data-plk-sheet-body]') : null;
    var sheetContent = sheetEl ? sheetEl.querySelector('[data-plk-sheet-content]') : null;
    var sheetOpenBtn = sheetEl ? sheetEl.querySelector('[data-plk-sheet-open]') : null;
    var sheetOpen = false;
    function mapLeftEdge(){
      var iw = window.innerWidth;
      if (iw < 750) return 0;
      var col = Math.min(408, iw);                                         /* full-height left column */
      if (FEATURED) return col + 16;                                       /* featured: the rail IS the left column */
      if (sheetOpen) return col + 24 + Math.min(408, iw - col - 64) + 16;  /* column + gap + detail panel + right pad */
      return col + 16;
    }
    function panOffset(){
      var iw = window.innerWidth;
      var left = mapLeftEdge();
      /* featured: centre the pin in the visible map area = right of the 408px rail (offset = rail width / 2) */
      var dx = FEATURED ? Math.round(Math.min(408, iw) / 2) : (left ? Math.round((left - 60) / 2) : 0);
      var dy = (iw < 750) ? -120 : 0; return [dx, dy];
    }
    var sheetCloseBtn = document.querySelector('[data-plk-sheet-close]');
    if (sheetCloseBtn){ sheetCloseBtn.addEventListener('click', closeDetail); }
    /* in-panel link intercept: keep tab/component navigation INSIDE the popup (mirrors wetu-command-center-embed-script) */
    var PDP_MEDIA_SELECTOR = 'media-gallery, [data-media-gallery], .media-gallery, .product__media, [data-media-id], [data-zoom], .pswp, .flickity, [data-product-media]';
    if (sheetContent){
      sheetContent.addEventListener('click', function(e){
        var a = e.target.closest && e.target.closest('a[href]'); if(!a) return;
        var href = a.getAttribute('href') || '';
        if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
        if (a.closest(PDP_MEDIA_SELECTOR)) return;   /* let gallery/lightbox links behave normally */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var url; try { url = new URL(href, window.location.origin); } catch(_){ return; }
        if (url.origin !== window.location.origin) return;
        e.preventDefault(); e.stopPropagation();
        loadPdpIntoPopup(url.pathname + url.search + url.hash);
      });
    }

    var map = null, ready = false;
    var selectedMarker = null, hoverMarker = null;
    var countryPopup = null, featurePopup = null;
    var areaFilter = null, lastCommittedBounds = null, moveTimer = null, framing = false;
    var hoverProvSlug = null;

    /* Vision-3 (doc 103) — country hover label (floating, follows the cursor over a live country). */
    function showCountryPopup(name){
      if(!map || !window.maplibregl || !name) return;
      if(!countryPopup){ countryPopup = new window.maplibregl.Popup({ closeButton:false, closeOnClick:false, className:'plk-country-popup', maxWidth:'none' }).trackPointer(); }
      countryPopup.setHTML('<div class="plk-country-popup__label">'+esc(name)+'</div>');
      if(!countryPopup.isOpen()) countryPopup.addTo(map);
    }
    function hideCountryPopup(){ if(countryPopup && countryPopup.isOpen()){ countryPopup.remove(); } }

    function requestLeader(){
      if(!leaderActive || !leaderOverlay) return;
      if(leaderTicking) return;
      leaderTicking = true;
      requestAnimationFrame(function(){ leaderTicking = false; drawLeader(); });
    }
    function drawLeader(){
      if(!leaderActive || !leaderTarget || !map || !leaderOverlay || !leaderHalo || !leaderPath || !leaderDot) return;
      var vw = window.innerWidth, vh = window.innerHeight, p0;
      try { p0 = map.project(leaderTarget); } catch(e){ return; }
      if(!p0 || p0.x < 0 || p0.x > vw || p0.y < 0 || p0.y > vh){
        leaderOverlay.style.opacity = '0';
        return;
      }
      var box = sField ? sField.getBoundingClientRect() : null;
      if(!box || !box.width){
        leaderOverlay.style.opacity = '0';
        return;
      }
      var p3 = { x: box.right, y: box.top + box.height/2 };
      var dx = p3.x - p0.x, dy = p3.y - p0.y;
      var p1 = { x: p0.x, y: p0.y - clamp(Math.abs(dy) * 0.5, 40, 250) };
      var p2 = { x: p3.x + clamp(Math.abs(dx) * 0.5, 60, 300), y: p3.y };
      var d = 'M ' + p0.x + ',' + p0.y + ' C ' + p1.x + ',' + p1.y + ' ' + p2.x + ',' + p2.y + ' ' + p3.x + ',' + p3.y;
      leaderHalo.setAttribute('d', d);
      leaderPath.setAttribute('d', d);
      leaderDot.setAttribute('cx', p0.x);
      leaderDot.setAttribute('cy', p0.y);
      leaderOverlay.style.opacity = '';
    }
    function enterCountryHover(name, lngLat){
      if(!sField || !leaderOverlay) return;
      if(!leaderActive) leaderSavedValue = sField.value || '';
      leaderActive = true;
      leaderTarget = lngLat;
      sField.value = name;
      if(searchBox) searchBox.classList.add('plk-search--hover');
      if(lngLat){
        drawLeader();
        leaderOverlay.classList.add('is-active');
      } else {
        leaderOverlay.classList.remove('is-active');
        if(leaderHalo) leaderHalo.setAttribute('d', '');
        if(leaderPath) leaderPath.setAttribute('d', '');
        if(leaderDot){ leaderDot.setAttribute('cx', ''); leaderDot.setAttribute('cy', ''); }
        leaderOverlay.style.opacity = '';
      }
    }
    function leaveCountryHover(){
      if(!leaderActive) return;
      leaderActive = false;
      leaderTarget = null;
      if(sField) sField.value = leaderSavedValue;
      if(searchBox) searchBox.classList.remove('plk-search--hover');
      if(leaderOverlay){ leaderOverlay.classList.remove('is-active'); leaderOverlay.style.opacity = ''; }
    }

    function pinsAllowed(){ return !!map && (showPins || areaFilter || map.getZoom() >= Z_GATE); }
    function applyGate(){
      if(!map) return;
      var v = pinsAllowed() ? 'visible' : 'none';
      ['pin-unclustered'].forEach(function(id){ if(map.getLayer(id)){ try{ map.setLayoutProperty(id,'visibility', v); }catch(e){} } });
      var pv = (map.getZoom() < Z_GATE) ? 'visible' : 'none';
      ['prov-fill','prov-line'].forEach(function(id){ if(map.getLayer(id)){ try{ map.setLayoutProperty(id,'visibility', pv); }catch(e){} } });
      /* Phase 3: tourism areas z8-13, city labels z>=11, both behind the "Areas" toggle (on default). */
      var av = (areasOn && map.getZoom() >= 8 && map.getZoom() < 13) ? 'visible' : 'none';
      ['area-fill','area-line','area-label'].forEach(function(id){ if(map.getLayer(id)){ try{ map.setLayoutProperty(id,'visibility', av); }catch(e){} } });
      var cv = (map.getZoom() >= 11) ? 'visible' : 'none';
      ['city-label'].forEach(function(id){ if(map.getLayer(id)){ try{ map.setLayoutProperty(id,'visibility', cv); }catch(e){} } });
      var tgl = document.querySelector('[data-plk-areastoggle]');
      if(tgl){ tgl.setAttribute('data-on', areasOn ? 'true' : 'false'); tgl.setAttribute('aria-checked', areasOn ? 'true' : 'false'); }
      var btn = document.querySelector('.plk-ctrl--pins'); if(btn) btn.setAttribute('data-on', showPins ? 'true' : 'false');
    }

    /* Phase 4 (doc 105): clickable province/region polygons for country/region pages. Low zoom
       shows the country sub-regions; zoom past Z_GATE hands off to the property pins. */
    function loadProvinces(){
      if(!map) return;
      if(location.hostname.indexOf('plekify') < 0) return;
      if(!COUNTRY_HANDLE) return;
      if(FRAME_KIND !== 'country' && FRAME_KIND !== 'region') return;
      if(map.getSource('provinces')) return;
      fetch(MAPS_BASE + '/' + COUNTRY_HANDLE + '.geojson').then(function(r){ if(!r.ok) throw new Error('no provinces'); return r.json(); }).then(function(fc){
        if(!map || map.getSource('provinces')) return;
        try {
          map.addSource('provinces',{ type:'geojson', data:fc, promoteId:'slug' });
          /* Phase 2e (brief 2.5): non-hover provinces are now fully transparent (outline read via
             prov-line only) — the old static #e9ecee @ 0.5 wash was the washed-out country. Hover
             green #bfe6c4 @ 0.9 is unchanged; the zoom gate + click-to-collection keep working. */
          map.addLayer({ id:'prov-fill', type:'fill', source:'provinces', paint:{
            'fill-color':['case',['==',['feature-state','hover'],true],'#bfe6c4','transparent'],
            'fill-opacity':['case',['==',['feature-state','hover'],true],0.9,0]
          }}, 'pin-unclustered');
          map.addLayer({ id:'prov-line', type:'line', source:'provinces', paint:{
            'line-color':'#64748b','line-opacity':0.5,'line-width':0.7
          }}, 'pin-unclustered');
        } catch(e){ return; }
        map.on('mousemove','prov-fill',function(e){
          var f=e.features&&e.features[0]; if(!f)return;
          var hasHandle=!!(f.properties&&f.properties.handle);
          map.getCanvas().style.cursor=hasHandle?'pointer':'';
          var id=f.properties&&f.properties.slug;
          if(!id||id===hoverProvSlug)return;
          if(hoverProvSlug!==null){ try{ map.setFeatureState({source:'provinces',id:hoverProvSlug},{hover:false}); }catch(_){} }
          hoverProvSlug=id;
          try{ map.setFeatureState({source:'provinces',id:id},{hover:true}); }catch(_){}
        });
        map.on('mouseleave','prov-fill',function(){
          if(hoverProvSlug!==null){ try{ map.setFeatureState({source:'provinces',id:hoverProvSlug},{hover:false}); }catch(_){} }
          hoverProvSlug=null; map.getCanvas().style.cursor='';
        });
        map.on('click','prov-fill',function(e){
          /* Phase 3: areas (z8-13) + city labels (z>=11) sit above this layer — when they own the
             point, the click belongs to selectArea/commitSearchArea, not region navigation.
             doc 206 §5 D1 (same class as countries-fill): pins + destination markers sit above
             too — a pin click must not ALSO navigate to the province collection underneath. */
          var own=[];
          try {
            var qLayers = ['area-fill','city-label','pin-unclustered','dest-markers'].filter(function(id){ return map.getLayer(id); });
            if (qLayers.length) own = map.queryRenderedFeatures(e.point, { layers: qLayers });
          }catch(_){}
          if(own&&own.length) return;
          var f=e.features&&e.features[0]; if(!f)return;
          var handle=f.properties&&f.properties.handle;
          if(handle){ window.location.href='/collections/'+handle; }
        });
        applyGate();
      }).catch(function(){ /* no provinces file — country outline + pins remain; do nothing */ });
    }
    /* Phase 3: zoom-gated tourism-area polygons + city labels (selectable drill-down below the
       provinces). Areas: low-opacity brand fill + outline + collision-aware labels, hover via
       setFeatureState, click -> fitBounds + filter the property list to member pins + crumb chip.
       Cities: label points, click -> fitBounds + immediate "search this area" commit (searcharea
       flow reuse). Mirrors loadProvinces (same source/guard layering); gates live in applyGate(). */
    function loadAreas(){
      if(!map) return;
      if(location.hostname.indexOf('plekify') < 0) return;
      if(!COUNTRY_HANDLE) return;
      if(FRAME_KIND !== 'country' && FRAME_KIND !== 'region') return;
      if(map.getSource('areas')) return;
      Promise.all([
        fetch(AREAS_BASE + '/' + COUNTRY_HANDLE + '.areas.geojson').then(function(r){ if(!r.ok) throw new Error('no areas'); return r.json(); }),
        fetch(AREAS_BASE + '/' + COUNTRY_HANDLE + '.cities.geojson').then(function(r){ if(!r.ok) throw new Error('no cities'); return r.json(); })
      ]).then(function(res){
        if(!map || map.getSource('areas')) return;
        var afc = res[0], cfc = res[1] || { features: [] };
        try {
          map.addSource('areas',{ type:'geojson', data:afc, promoteId:'slug' });
          var mobile = window.innerWidth < 750;
          map.addLayer({ id:'area-fill', type:'fill', source:'areas', paint:{
            'fill-color':'#6fae3e',
            'fill-opacity':['case',['==',['feature-state','hover'],true],0.35,mobile?0.09:0.12]
          }}, 'pin-unclustered');
          map.addLayer({ id:'area-line', type:'line', source:'areas', paint:{
            'line-color':'#6fae3e','line-opacity':0.65,'line-width':1
          }}, 'pin-unclustered');
          map.addLayer({ id:'area-label', type:'symbol', source:'areas', layout:{
            'text-field':['get','name'], 'text-font':['Noto Sans Bold'], 'text-size':mobile?11:12,
            'text-letter-spacing':0.02, 'text-max-width':10, 'text-allow-overlap':false, 'text-padding':5
          }, paint:{ 'text-color':'#3d6b1f', 'text-halo-color':'#ffffff', 'text-halo-width':1.4 }}, 'pin-unclustered');
          map.addSource('cities',{ type:'geojson', data:cfc, promoteId:'slug' });
          map.addLayer({ id:'city-label', type:'symbol', source:'cities', layout:{
            'text-field':['get','name'], 'text-font':['Noto Sans Regular'], 'text-size':mobile?10:11,
            'text-allow-overlap':false, 'text-padding':2
          }, paint:{ 'text-color':'#475569', 'text-halo-color':'#ffffff', 'text-halo-width':1.2 }}, 'pin-unclustered');
        } catch(e){ return; }
        (afc.features||[]).forEach(function(f){ if(f && f.properties && f.properties.slug) areaById[f.properties.slug] = f; });
        var tgl = document.querySelector('[data-plk-areastoggle]'); if(tgl){ tgl.hidden = false; }
        map.on('mousemove','area-fill',function(e){
          var f=e.features&&e.features[0]; if(!f)return;
          map.getCanvas().style.cursor='pointer';
          var id=f.properties&&f.properties.slug;
          if(!id||id===hoverAreaSlug)return;
          if(hoverAreaSlug!==null){ try{ map.setFeatureState({source:'areas',id:hoverAreaSlug},{hover:false}); }catch(_){} }
          hoverAreaSlug=id;
          try{ map.setFeatureState({source:'areas',id:id},{hover:true}); }catch(_){}
        });
        map.on('mouseleave','area-fill',function(){
          if(hoverAreaSlug!==null){ try{ map.setFeatureState({source:'areas',id:hoverAreaSlug},{hover:false}); }catch(_){} }
          hoverAreaSlug=null; map.getCanvas().style.cursor='';
        });
        map.on('click','area-fill',function(e){
          var f=e.features&&e.features[0]; if(!f)return;
          var slug=f.properties&&f.properties.slug; if(slug) selectArea(slug);
        });
        map.on('click','city-label',function(e){
          var f=e.features&&e.features[0]; if(!f)return;
          var co=f.geometry&&f.geometry.coordinates;
          if(!co||co.length<2) return;
          /* Phase 3d: city click is a proximity query, not a fixed tiny viewport. Widen the box
             (×2, ×4, ×8 capped at ~1.5°/1.0°) until the current base pins return non-empty, then
             commit that bounds. If even the cap is empty, commit the cap so the list shows the empty
             state (fail-closed, no console noise). */
          var steps = [
            { lon: 0.22, lat: 0.14 },
            { lon: 0.44, lat: 0.28 },
            { lon: 0.88, lat: 0.56 },
            { lon: 1.50, lat: 1.00 }
          ];
          var bounds = null, hit = false;
          for (var i = 0; i < steps.length; i++) {
            var b = new window.maplibregl.LngLatBounds([co[0]-steps[i].lon, co[1]-steps[i].lat], [co[0]+steps[i].lon, co[1]+steps[i].lat]);
            var count = 0;
            if (pinIndex) {
              try { count = pinIndex.idx.search(b.getWest(), b.getSouth(), b.getEast(), b.getNorth()).length; } catch(_){}
            } else {
              count = basePins.filter(function(p){ return p.lon != null && p.lat != null && inBounds(p, b); }).length;
            }
            bounds = b;
            if (count > 0) { hit = true; break; }
          }
          if (!bounds) return;
          try {
            commitSearchArea(bounds);
            map.fitBounds(bounds, { padding:padFrame(), maxZoom:12, linear:false, duration:600 });
          } catch(_){}
        });
        applyGate();
      }).catch(function(){ /* no areas/cities file — provinces + pins remain; do nothing */ });
    }
    function selectArea(slug){
      var f=areaById[slug]; if(!f)return;
      setActiveArea(f);
      var b=fcBbox(f);
      try { map.fitBounds([[b[0],b[1]],[b[2],b[3]]],{ padding:padFrame(), maxZoom:12.5, linear:false, duration:650 }); } catch(e){}
    }
    function setActiveArea(f){
      if(!f||!f.properties) return;
      activeArea={ slug:f.properties.slug, name:f.properties.name, members:{} };
      (f.properties.member_handles||[]).forEach(function(h){ if(h) activeArea.members[h]=1; });
      var crumb=document.querySelector('[data-plk-areacrumb]');
      if(crumb){ crumb.textContent=String(f.properties.name)+' ×'; crumb.hidden=false; }
      showClearIfActive();
      rebuildBasePins(); setListType('properties'); resetListScroll(); refreshSource(); applyGate();
      if(searchBtn) searchBtn.setAttribute('data-show','false');
    }
    function clearActiveArea(){
      activeArea=null;
      var crumb=document.querySelector('[data-plk-areacrumb]'); if(crumb){ crumb.hidden=true; }
      showClearIfActive();
      rebuildBasePins(); resetListScroll(); refreshSource(); renderRows(); applyGate();
    }
    var areasToggleBtn=document.querySelector('[data-plk-areastoggle]');
    if(areasToggleBtn){ areasToggleBtn.addEventListener('click', function(){
      areasOn=!areasOn;
      if(!areasOn) clearActiveArea();
      applyGate();
    }); }
    var areaCrumbBtn=document.querySelector('[data-plk-areacrumb]');
    if(areaCrumbBtn){ areaCrumbBtn.addEventListener('click', function(){ clearActiveArea(); }); }
    /* Phase 1: country fill is always transparent — the opaque white overlay is removed.
       Outlines (countries-line) + green province hover (prov-fill) remain. Satellite toggle only
       switches the raster tile layer. */
    function setSatellite(on){
      if(!map) return;
      try { map.setLayoutProperty('satellite-tiles','visibility', on ? 'visible' : 'none'); } catch(e){}   /* no-op if the source is absent */
    }
    function setCountryHighlight(iso3){
      if(!map) return;
      /* Vision-4 (doc 105): tint + halo + crisp line all follow the active country (or none). */
      var f = iso3 ? ['==',['get','iso3'], iso3] : ['==',['get','iso3'],'__none__'];
      ['country-fill-hi','country-outline-halo','country-outline-hi'].forEach(function(id){ try { map.setFilter(id, f); } catch(e){} });
    }

    /* ---------- DETAIL (expansive PDP popup via fetch+inject of #MainContent) ---------- */
    /* Vision-4 (doc 105): the sheet is NOT shown with a shimmer skeleton. The fetched #MainContent
       is parsed + injected first; only then does the sheet reveal (slide-in from the left + fade),
       so the user sees fully-rendered content, never an empty skeleton. A minimal spinner appears
       only if the fetch is slow (>400ms) so the click never looks stuck. */
    var sheetLoadTimer = null;
    function revealSheet(){
      if(!sheetEl) return;
      sheetEl.hidden = false;
      sheetEl.classList.remove('plk-sheet--visible');
      void sheetEl.offsetWidth;                       /* reflow so the transition replays on reopen */
      requestAnimationFrame(function(){ if(sheetEl) sheetEl.classList.add('plk-sheet--visible'); });
    }

    /* Wave 3 Phase 2: re-initialise the tab switcher + Horizon-style gallery for the injected
       plekify-property PDP. The section's script block is inert after innerHTML injection,
       so we bind a minimal, popup-scoped implementation here. */
    function initPlekifyPropertyPopup(sheetContent){
      if(!sheetContent) return;

      /* ---------- Tab switcher ---------- */
      var tabs = sheetContent.querySelectorAll('[data-tab]');
      var panels = sheetContent.querySelectorAll('[data-tab-panel]');
      if(tabs.length && panels.length){
        function switchTab(tabId){
          Array.prototype.forEach.call(tabs, function(t){
            var active = t.dataset.tab === tabId;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', String(active));
          });
          var activePanel = null;
          Array.prototype.forEach.call(panels, function(p){
            var active = p.dataset.tabPanel === tabId;
            p.classList.toggle('is-active', active);
            p.hidden = !active;
            if (active) activePanel = p;
          });
          /* Plekify map-popup tab fix (2026-08-08): do NOT replaceState('#tab') — on the map page
             the URL hash carries the map position (#zoom/lat/lon, set in updateViewHash) and
             clobbering it corrupts map state. Reveal the panel by scrolling the sheet body so its
             top sits just under the sticky tab nav. */
          if (activePanel) {
            var navEl = sheetContent.querySelector('.property-tabs-nav');
            var sheetBody = sheetContent.closest('.plk-sheet__body');
            if (sheetBody) {
              var shift = activePanel.getBoundingClientRect().top - sheetBody.getBoundingClientRect().top - (navEl ? navEl.offsetHeight : 0);
              if (shift > 4 || shift < -4) sheetBody.scrollTo({ top: sheetBody.scrollTop + shift, behavior: 'smooth' });
            }
          }
        }
        Array.prototype.forEach.call(tabs, function(tab){
          tab.addEventListener('click', function(){ switchTab(tab.dataset.tab); });
        });
      }

      /* ---------- Gallery lightbox (popup-scoped) ---------- */
      var dialog = sheetContent.querySelector('[data-gallery-dialog]');
      var stage = sheetContent.querySelector('[data-gallery-dialog-stage]');
      var thumbs = sheetContent.querySelector('[data-gallery-dialog-thumbs]');
      var figures = stage ? Array.from(stage.querySelectorAll('[data-gallery-dialog-figure]')) : [];
      var thumbButtons = thumbs ? Array.from(thumbs.querySelectorAll('[data-gallery-dialog-thumb]')) : [];
      var currentIndex = 0;

      if(dialog && stage && figures.length){
        function updateThumbs(idx){
          thumbButtons.forEach(function(btn, i){
            btn.classList.toggle('is-active', i === idx);
            if(i === idx && thumbs) btn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          });
        }
        function scrollTo(index){
          if(!figures[index]) return;
          currentIndex = index;
          figures[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
          updateThumbs(index);
        }
        function open(index){
          currentIndex = index || 0;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          var target = figures[currentIndex];
          if(target) target.scrollIntoView({ behavior: 'instant', block: 'start' });
          updateThumbs(currentIndex);
        }
        function close(){
          dialog.close();
          document.body.style.overflow = '';
        }

        dialog.addEventListener('click', function(e){
          if(e.target === dialog || e.target.hasAttribute('data-gallery-dialog-backdrop')) close();
        });
        var closeBtn = dialog.querySelector('[data-gallery-dialog-close]');
        if(closeBtn) closeBtn.addEventListener('click', function(e){ e.stopPropagation(); close(); });
        figures.forEach(function(fig){
          fig.addEventListener('click', function(e){
            if(e.target === fig || e.target.tagName === 'IMG') close();
          });
        });
        document.addEventListener('keydown', function(e){
          if(!dialog.open) return;
          if(e.key === 'Escape'){ e.preventDefault(); close(); }
          if(e.key === 'ArrowDown' || e.key === 'ArrowRight' || e.key === 'PageDown' || e.key === ' '){
            e.preventDefault(); if(currentIndex < figures.length - 1) scrollTo(currentIndex + 1);
          }
          if(e.key === 'ArrowUp' || e.key === 'ArrowLeft' || e.key === 'PageUp'){
            e.preventDefault(); if(currentIndex > 0) scrollTo(currentIndex - 1);
          }
        });

        var popupGallery = { open: open, close: close, scrollTo: scrollTo };
        window.PlekifyPopupGallery = popupGallery;
        window.PlekifyGallery = popupGallery;
      }

      /* ---------- Hero video (popup-scoped) ---------- */
      /* Phase 2C parity: the hero section's standalone init script is dropped on
         innerHTML inject, so its video never played in the popup (sat inert behind
         the poster, .is-ready never added). Replicate the standalone reveal/play
         scoped to this sheet's hero only. All listeners attach to the video element
         itself — closeDetail's sheetContent.innerHTML='' detaches them and stops
         playback, so nothing accumulates across opens. */
      var hero = sheetContent.querySelector('[data-plekify-property-hero]');
      var video = hero ? hero.querySelector('video') : null;
      if(video){
        var poster = hero.querySelector('.plekify-property-hero__poster');
        var revealVideo = function(){
          video.classList.add('is-ready');
        };
        var attemptPlay = function(){
          var p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function() {});
          }
        };
        if (video.readyState >= 2) {
          revealVideo();
          attemptPlay();
        } else {
          video.addEventListener('loadeddata', function onLoaded(){
            revealVideo();
            video.removeEventListener('loadeddata', onLoaded);
          });
          video.addEventListener('canplay', function onCanPlay(){
            revealVideo();
            attemptPlay();
            video.removeEventListener('canplay', onCanPlay);
          });
        }
        /* ~4s fallback: reveal + play even if no frame events fired. isConnected guard
           makes a timer that outlives the sheet (closed via innerHTML='') a no-op. */
        setTimeout(function(){
          if(!video.isConnected) return;
          if(!video.classList.contains('is-ready')){
            revealVideo();
            attemptPlay();
          }
        }, 4000);
        attemptPlay();
      }
    }

    function loadPdpIntoPopup(url){
      if(!sheetContent) return;
      if(sheetOpenBtn){ sheetOpenBtn.setAttribute('href', url); }   /* the open-in-new-tab icon always points at the live property page */
      sheetContent.classList.remove('plk-sheet__content--ready');
      sheetContent.innerHTML = '';
      if(sheetBody){ sheetBody.scrollTop = 0; }
      if(sheetLoadTimer){ clearTimeout(sheetLoadTimer); }
      sheetLoadTimer = setTimeout(function(){        /* slow-load fallback: a clean spinner, not a skeleton */
        if(sheetContent && !sheetContent.innerHTML.trim()){ sheetContent.innerHTML = '<div class="plk-sheet__spin" role="status" aria-label="Loading property"><span class="plk-sheet__spinner"></span></div>'; }
      }, 400);
      fetch(url, { credentials:'same-origin' })
        .then(function(r){ return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var mc = doc.querySelector('#MainContent');
          if(sheetLoadTimer){ clearTimeout(sheetLoadTimer); sheetLoadTimer = null; }
          sheetContent.innerHTML = mc ? mc.innerHTML : '';
          initPlekifyPropertyPopup(sheetContent);
          /* dispatch shopify:section:load so injected sections (hero video, tabs, galleries) initialise */
          var secs = sheetContent.querySelectorAll('[id^="shopify-section-"]');
          Array.prototype.forEach.call(secs, function(sec){
            var id = String(sec.id || '').replace(/^shopify-section-/, '');
            try { sec.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles:true, detail:{ sectionId:id } })); } catch(e){}
          });
          /* Vision-4 follow-up (founder): drop the "Map" tab — we are already in a map context. */
          var _mt = sheetContent.querySelectorAll('.microsite-tabs__link');
          Array.prototype.forEach.call(_mt, function(t){ if ((t.textContent || '').trim() === 'Map') t.parentNode && t.parentNode.removeChild(t); });
          /* Vision-4 follow-up (Kimi): remove the hidden duplicate title node (.view-product-title)
             entirely — the title already shows on the hero overlay. */
          sheetContent.querySelectorAll('.view-product-title').forEach(function(el){ el.parentNode && el.parentNode.removeChild(el); });
          /* Vision-4 follow-up (Kimi QA): upgrade the injected <zoom-dialog> so the photo gallery
             opens the full-viewport overlay (same as the live PDP). No-op if already defined.
             doc 206 §5 D3: dynamic import() in a CLASSIC script is CDN-transpiled to
             require() → ReferenceError a sync try/catch can never catch. A module
             <script> tag is served as-is and resolves @theme/* via the page import map. */
          if (sheetContent.querySelector('zoom-dialog') && !window.customElements.get('zoom-dialog') && ZOOM_DIALOG_JS
              && !document.querySelector('script[data-plk-zoom-dialog]')) {
            var _zd = document.createElement('script');
            _zd.type = 'module';
            _zd.src = ZOOM_DIALOG_JS;
            _zd.setAttribute('data-plk-zoom-dialog', '1');
            document.head.appendChild(_zd);
          }
          revealSheet();
        })
        .catch(function(){ if(sheetLoadTimer){ clearTimeout(sheetLoadTimer); sheetLoadTimer = null; } sheetContent.innerHTML = '<div class="plk-sheet__err">This property could not be loaded. <a href="'+esc(url)+'" target="_blank" rel="noopener">Open the full page &rarr;</a></div>'; revealSheet(); });
    }
    function openDetail(pin){
      if(!panel || !sheetEl || !sheetContent) return;
      var root = document.querySelector('[data-plk-mapmode]');
      if(root){ root.setAttribute('data-sheet-open','true'); }   /* Vision-3: column STAYS open; this only suppresses the 'search this area' chip */
      sheetOpen = true;   /* set now so mapLeftEdge()/panOffset() pre-center for the sheet before it reveals */
      renderSheetCrumb(pin);
      var url = (pin && pin.url) ? pin.url : ('/products/' + (pin && pin.handle ? pin.handle : ''));
      loadPdpIntoPopup(url);   /* reveals the sheet itself once the content is ready */
    }
    function closeDetail(){
      if(FEATURED && window.innerWidth >= 750){ return; }   /* featured rail is persistent on desktop (B3.1); mobile keeps the × */
      if(sheetEl){ sheetEl.hidden = true; } sheetOpen = false;
      var root = document.querySelector('[data-plk-mapmode]');
      if(root){ root.setAttribute('data-sheet-open','false'); }
      if(sheetContent){ sheetContent.innerHTML = ''; }   /* free the injected DOM (stops hero video, drops memory) */
      clearSelected();
      var row = panel ? panel.querySelector('.plk-row--active') : null; if(row) row.classList.remove('plk-row--active');
    }

    function setSelected(pin){
      clearSelected();
      if(!map || !window.maplibregl) return;
      try {
        var el = document.createElement('div'); el.className = 'plk-pin-ring';
        selectedMarker = new window.maplibregl.Marker({ element: el, anchor: 'center', tabIndex: -1 }).setLngLat([pin.lon, pin.lat]).addTo(map);
        /* Vision-3 (doc 103): a small title bubble at the selected pin marking the featured property. */
        if (pin && pin.title){
          featurePopup = new window.maplibregl.Popup({ closeButton:false, closeOnClick:false, className:'plk-feature-popup', offset: 18, maxWidth:'260px' })
            .setHTML('<div class="plk-feature-popup__title">'+esc(pin.title)+'</div>')
            .setLngLat([pin.lon, pin.lat]).addTo(map);
        }
      } catch(e){}
    }
    function clearSelected(){ if(selectedMarker){ try{ selectedMarker.remove(); }catch(e){} selectedMarker = null; } if(featurePopup){ try{ featurePopup.remove(); }catch(e){} featurePopup = null; } if(destSelectedMarker){ try{ destSelectedMarker.remove(); }catch(e){} destSelectedMarker = null; } if(destHoverMarker){ try{ destHoverMarker.remove(); }catch(e){} destHoverMarker = null; } }
    function showHover(pin){
      clearHover();
      if(!map || !window.maplibregl) return;
      try { var el = document.createElement('div'); el.className = 'plk-pin-hover';
        hoverMarker = new window.maplibregl.Marker({ element: el, anchor: 'center', tabIndex: -1 }).setLngLat([pin.lon, pin.lat]).addTo(map);
      } catch(e){}
    }
    function clearHover(){ if(hoverMarker){ try{ hoverMarker.remove(); }catch(e){} hoverMarker = null; } }

    /* Phase 2: bidirectional pin->list highlight. Scrolls the virtualizer to the matching row and
       applies the active state. Fallback to scrollIntoView if the virtualizer is not running. */
    function highlightRow(handle){
      if (!panel) return;
      panel.querySelectorAll('.plk-row--active').forEach(function(r){ r.classList.remove('plk-row--active'); });
      var row = panel.querySelector('.plk-row[data-handle="'+cssEsc(handle)+'"]');
      if (row){ row.classList.add('plk-row--active'); }
      if (virtualizer){
        var list = effectivePins();
        var idx = -1;
        for (var i=0; i<list.length; i++){ if (list[i].handle === handle){ idx = i; break; } }
        if (idx >= 0){ virtualizer.scrollToIndex(idx, { align: 'center', behavior: 'auto' }); }
      } else if (row) {
        row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
    function clearHighlightRow(){ if (panel){ panel.querySelectorAll('.plk-row--active').forEach(function(r){ r.classList.remove('plk-row--active'); }); } }

    function selectPin(handle, opts){
      opts = opts || {};
      var pin = findPin(handle);
      if(!pin) return;
      setSelected(pin);
      openDetail(pin);
      /* scroll matching list row into view + mark active. T5 E: route through highlightRow so
         VIRTUALIZED lists get the virtualizer.scrollToIndex (plain scrollIntoView cannot reach a
         row that isn't mounted in the DOM window). */
      highlightRow(handle);
      /* Phase 3b: also scroll + activate the matching NATIVE grid row (embedded mode). Best-effort —
         the native grid is infinite-scroll (only loaded rows are in the DOM); if the row isn't loaded
         yet, skip (the sheet + pin ring + easeTo still work). No-op on ?view=map (no .collection-wrapper). */
      var nRows = document.querySelectorAll('.collection-wrapper .plk-row');
      for (var i = 0; i < nRows.length; i++) {
        var rh = ''; try { rh = new URL(nRows[i].href, location.origin).pathname.replace(/^\/products\//, ''); } catch(e){}
        if (rh === handle) {
          document.querySelectorAll('.collection-wrapper .plk-row').forEach(function(r){ r.classList.remove('plk-row--active'); });
          nRows[i].classList.add('plk-row--active');
          try { nRows[i].scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch(e){}
          break;
        }
      }
      if(map){
        try { map.easeTo({ center:[pin.lon, pin.lat], zoom: Math.max(map.getZoom(), 13), offset: panOffset(), duration: 500 }); } catch(e){}
      }
      if(!opts.silent){ setFocusUrl(handle); }
    }
    function cssEsc(s){ return String(s==null?'':s).replace(/["\\]/g,'\\$&'); }
    function setFocusUrl(handle){
      try { var u = new URL(location.href); if(handle){ u.searchParams.set('focus', handle); } else { u.searchParams.delete('focus'); } history.replaceState(null,'',u.href); } catch(e){}
    }

    /* Phase 3b: wire the native main-collection grid rows ↔ map pins (embedded mode).
       Event delegation on .collection-wrapper so infinite-scroll-loaded rows are handled.
       No-op on ?view=map (no .collection-wrapper). */
    function wireNativeGrid(){
      var grid = document.querySelector('.collection-wrapper');
      if(!grid){                              /* ?view=map has no native grid; OR (edge case) DOM not yet parsed at init */
        if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', wireNativeGrid, { once:true }); }
        return;
      }
      function rowHandle(row){ try { return new URL(row.href, location.origin).pathname.replace(/^\/products\//, ''); } catch(e){ return ''; } }
      function pinFor(handle){ return findPin(handle); }
      grid.addEventListener('click', function(e){
        var row = e.target.closest('.plk-row'); if(!row) return;
        if (row.hasAttribute('data-dest')) return;   /* Phase 2a: embedded destination rows have their own click handler */
        if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) return;   /* 3c: let modifier-clicks open the PDP natively (new tab) */
        e.preventDefault();                   /* JS users get the sheet, not PDP nav; href stays crawlable (no-JS fallback) */
        var handle = rowHandle(row); if(!handle) return;
        var pin = pinFor(handle);
        document.querySelectorAll('.collection-wrapper .plk-row').forEach(function(r){ r.classList.remove('plk-row--active'); });
        row.classList.add('plk-row--active');
        if(pin){
          selectPin(handle, { silent:false });   /* sheet + pin ring + easeTo + native-row scroll + setFocusUrl */
        } else {
          /* no geo pin for this property — open the sheet by handle only (no ring/easeTo) */
          openDetail({ handle: handle, url: row.href });
          setFocusUrl(handle);
        }
      });
      var hoverRow = null;
      grid.addEventListener('mouseover', function(e){
        var row = e.target.closest('.plk-row'); if(!row || row === hoverRow) return;
        hoverRow = row;
        var pin = pinFor(rowHandle(row));
        if(pin){ showHover(pin); } else { clearHover(); }
      });
      grid.addEventListener('mouseout', function(e){
        var row = e.target.closest('.plk-row'); if(!row) return;
        var related = e.relatedTarget; if(related && row.contains(related)) return;   /* still inside the row */
        hoverRow = null; clearHover();
      });
    }

    /* ---------- LIST render (incremental window append via IntersectionObserver sentinel) ---------- */
    var LIST_WINDOW = 40;
    var listRendered = 0;
    var listObserver = null;
    function rowHtml(p){
      var cat = '';   /* Vision-4 follow-up (founder): do not show the accommodation type (Lodge/Hotel/...) in the list rows */
      var meta = [];
      if(p.area) meta.push(esc(p.area)); else if(p.region) meta.push(esc(p.region));
      if(p.country) meta.push(esc(p.country));
      var media = p.image ? '<img class="plk-row__thumb" src="'+esc(p.image)+'" alt="" loading="lazy">' : '<div class="plk-row__ph">'+(p.category?esc(String(p.category).charAt(0).toUpperCase()):'&#x25CF;')+'</div>';
      return '<button class="plk-row" type="button" data-handle="'+cssEsc(p.handle)+'" data-lat="'+p.lat+'" data-lon="'+p.lon+'">'
        + '<span class="plk-row__media">'+media+'</span>'
        + '<span class="plk-row__body">'+cat+'<span class="plk-row__title">'+esc(p.title)+'</span>'
        + (p.copyShort?'<span class="plk-row__tagline">'+esc(p.copyShort)+'</span>':'')
        + (meta.length?'<span class="plk-row__meta">'+meta.join(' &middot; ')+'</span>':'')+'</span></button>';
    }
    function wireRow(row){
      var h = row.getAttribute('data-handle');
      row.addEventListener('click', function(){ selectPin(h); });
      /* T5 Phase E: pulsing hover marker (Phase 2) + gentle easeTo on mouseenter (row-hover -> pin). */
      row.addEventListener('mouseenter', function(){ var pp = PINS.filter(function(x){return x.handle===h;})[0]; if(pp){ showHover(pp); hoverEaseTo(pp.lon, pp.lat); } });
      row.addEventListener('mouseleave', clearHover);
      row.addEventListener('focus', function(){ var pp = PINS.filter(function(x){return x.handle===h;})[0]; if(pp) showHover(pp); });
      row.addEventListener('blur', clearHover);
    }

    /* ---------- Phase 2: virtualized list (@tanstack/virtual-core) + scroll-append fallback ---------- */
    var rowsEl = panel ? panel.querySelector('[data-plk-rows]') : null;
    var countEl = panel ? panel.querySelector('[data-plk-count]') : null;
    var titleEl = panel ? panel.querySelector('[data-plk-title]') : null;
    var virtualizer = null;
    function updateListTitle(){ if (titleEl){ titleEl.textContent = (MAP_VIEW === 'collection' ? (COLLECTION_TITLE || 'Properties') : 'Properties'); } }
    function updateListCount(list){
      if (!countEl) return;
      var labelParts = [];
      if (activeChip) labelParts.push(activeChip);
      if (activeRegion) labelParts.push(activeRegion);
      if (activeArea) labelParts.push(activeArea.name);
      var label = labelParts.length ? labelParts.join(' + ') : (areaFilter ? 'in view' : '');
      countEl.textContent = list.length + (label ? ' ' + label : '') + ' propert' + (list.length===1?'y':'ies');
    }
    function curatedBlock(){ if (!CURATED || !CURATED.ups.length) return ''; var h='<div class="plk-panel__empty" style="text-align:left">We&rsquo;re curating more stays in '+esc(CURATED.suburb)+'. Explore '; for (var i=0;i<CURATED.ups.length;i++){ if (i) h += ' / '; h += '<a href="'+CURATED.ups[i][1]+'">'+esc(CURATED.ups[i][0])+'</a>'; } return h+'</div>'; }
    function renderListEmpty(msg){
      if (!rowsEl) return;
      if (listObserver) { listObserver.disconnect(); listObserver = null; }
      listRendered = 0;
      rowsEl.innerHTML = CURATED ? curatedBlock() : '<div class="plk-panel__empty">' + msg + '</div>';
      if (countEl) countEl.textContent = '0';
    }
    /* Phase 2d fix: the vendored tanstack-virtual-core setOptions() REPLACES the options object with a
       fixed defaults set + the passed keys — it drops estimateSize / getScrollElement / scrollToFn /
       observers / onChange unless re-passed. Build the FULL option set here and re-pass it on every
       rebind (count changes; everything else is re-stated for a clean setOptions). */
    function virtualizerOptsFor(count){
      return {
        count: count,
        getScrollElement: function(){ return rowsEl; },
        estimateSize: function(){ return 96; },
        scrollToFn: window.VirtualCore.elementScroll,
        observeElementRect: window.VirtualCore.observeElementRect,
        observeElementOffset: window.VirtualCore.observeElementOffset,
        measureElement: function(el, entry, instance){ return el.getBoundingClientRect().height; },
        overscan: 6,
        onChange: function(inst, sync){ renderVirtualRows(); }
      };
    }
    function initVirtualizer(){
      if (virtualizer || !rowsEl || !window.VirtualCore) return false;
      try {
        virtualizer = new window.VirtualCore.Virtualizer(virtualizerOptsFor(effectivePins().length));
        virtualizer._willUpdate();
        virtualizer._didMount();   /* attach ResizeObserver + scroll listener now that the scroll element exists */
        return true;
      } catch(e) { if (window.console) console.warn('[plk-map] virtualizer init failed:', e); return false; }
    }
    function renderVirtualRows(){
      if (!virtualizer || !rowsEl) return;
      /* Phase 2f: the virtualizer can fire an async onChange after we switch to destinations mode
         and replace the rows with destination items; guard so it does not clobber them. */
      if (listType === 'destinations') return;
      var items = virtualizer.getVirtualItems();
      var totalSize = virtualizer.getTotalSize();
      var list = effectivePins();   /* Phase 2d: resolve the sorted+filtered list once, not per item */
      var html = '<div class="plk-virtual__viewport" style="position:relative;height:' + totalSize + 'px;">';
      items.forEach(function(item){
        var p = list[item.index];
        if (!p) return;
        html += '<div class="plk-virtual__row" data-index="' + item.index + '" data-handle="' + cssEsc(p.handle) + '" style="position:absolute;top:0;left:0;width:100%;transform:translateY(' + item.start + 'px);">' + rowHtml(p) + '</div>';
      });
      html += '</div>';
      rowsEl.innerHTML = html;
      rowsEl.querySelectorAll('.plk-row').forEach(function(row){ wireRow(row); });
      items.forEach(function(item){
        var el = rowsEl.querySelector('.plk-virtual__row[data-index="' + item.index + '"]');
        if (el) virtualizer.measureElement(el);
      });
    }
    function renderVirtualList(){
      if (!panel) return;
      updateListTitle();
      if (clearBtn) clearBtn.hidden = !(activeChip || activeRegion || areaFilter || activeArea || sortMode !== 'featured');
      var list = effectivePins();
      if (!PINS.length){ renderListEmpty('No mapped properties in this collection yet.'); return; }
      if (!list.length){ renderListEmpty('No properties match ' + (activeChip ? '&ldquo;' + esc(activeChip) + '&rdquo;' : 'this view') + '.'); return; }
      updateListCount(list);
      if (!virtualizer) { if (initVirtualizer()) renderVirtualRows(); }
      else { virtualizer.setOptions(virtualizerOptsFor(list.length)); virtualizer.measure(); renderVirtualRows(); }
    }
    function resetListScroll(){
      if (!rowsEl) return;
      if (virtualizer){ try { virtualizer.scrollToOffset(0, { behavior: 'auto' }); } catch(e){ rowsEl.scrollTop = 0; } }
      else { rowsEl.scrollTop = 0; }
    }

    function renderList(filterFn, append){
      if(!panel) return;
      updateListTitle();
      var list = filterFn ? PINS.filter(filterFn) : currentPins();
      if(clearBtn){ clearBtn.hidden = !(activeChip || areaFilter || activeArea); }
      if(!PINS.length){ renderListEmpty('No mapped properties in this collection yet.'); return; }
      if(!list.length){ renderListEmpty('No properties match '+(activeChip?'&ldquo;'+esc(activeChip)+'&rdquo;':'this view')+'.'); return; }
      updateListCount(list);
      if (!append) {
        listRendered = 0;
        rowsEl.innerHTML = '';
        if (listObserver) { listObserver.disconnect(); listObserver = null; }
      }
      var end = Math.min(listRendered + LIST_WINDOW, list.length);
      var html = '';
      for (var i = listRendered; i < end; i++) { html += rowHtml(list[i]); }
      if (html) {
        rowsEl.insertAdjacentHTML('beforeend', html);
        rowsEl.querySelectorAll('.plk-row:not([data-wired])').forEach(function(row){ row.setAttribute('data-wired','true'); wireRow(row); });
      }
      listRendered = end;
      /* IntersectionObserver sentinel: append next window when the bottom of the scrollable area approaches. */
      if (listRendered < list.length) {
        var sentinel = rowsEl.querySelector('.plk-rows__sentinel');
        if (!sentinel) {
          sentinel = document.createElement('div');
          sentinel.className = 'plk-rows__sentinel';
          sentinel.style.height = '1px';
          rowsEl.appendChild(sentinel);
        }
        if (!listObserver) {
          listObserver = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              if (entry.isIntersecting) { renderList(null, true); }
            });
          }, { root: rowsEl, rootMargin: '0px 0px 200px 0px' });
        }
        listObserver.observe(sentinel);
      } else {
        var sentinel = rowsEl.querySelector('.plk-rows__sentinel');
        if (sentinel) sentinel.remove();
        if (listObserver) { listObserver.disconnect(); listObserver = null; }
      }
    }

    /* ---------- Phase 1: client-side page fetch to bypass Shopify's 250-pin Liquid cap ----------
       The collection page only renders the first 250 pins server-side. Fetch the same page
       with ?page=N and parse the baked plk-map-pins script to append the rest. No new app
       endpoint or theme file required; all data comes from the existing section bake.
       2026-08-14 (250-cap fix, executor DeepSeek): the older loop compared the POST-FILTER pin
       count against the 250/page slice, so a page-1 bake of 249-250 pins (any single client-side
       filtered pin) silently skipped page 2 — the panel parked at 249/250 forever. The rewritten
       loop (a) is gated on META.pinPages (baked paginate.pages — the true server slice), (b) walks pages 2..N until a
       page returns 0 NEW pins or comes up short (<250 raw — the last page), with a hard page cap
       so a params-blind storefront cache that re-serves page 1 can never spin an unbounded fetch
       storm, and (c) rebuilds the base set + spatial index + region facet + chips + list + count
       ONCE when the appended set settles. Map pins, virtualized list and the header count all
       reflect the appended set (rebuildBasePins rebuilds the Flatbush index; renderRows ->
       renderVirtualList refreshes the count via updateListCount). */
    var EXTRA_PAGES_LOADED = false;
    var MAX_PAGES = 12;   /* 250/page -> up to 3000 pins worst case; hard safety */
    function loadMorePages(){
      if (EXTRA_PAGES_LOADED) return;
      EXTRA_PAGES_LOADED = true;
      if (MAP_VIEW !== 'collection' || !COLLECTION_HANDLE || !PINS.length) return;
      if ((META.pinPages || 1) <= 1) return; /* baked paginate.pages: 1 page = nothing to append */
      var page = 2;
      var seen = {};
      PINS.forEach(function(p){ if (p && p.handle) seen[p.handle] = true; });
      var usable = false, done = false;
      function finish(){
        if (!usable) return;   /* nothing appended (fetch failed or all-duplicate pages) — fail closed */
        rebuildBasePins();     /* grow the base set + spatial index. */
        buildChips();          /* chip counts grow with the appended pins. */
        buildRegionOptions();  /* the region facet grows with the appended pages. */
        refreshSource();       /* map pins layer. */
        renderRows();          /* virtualized list + header count (updateListCount). */
      }
      function fetchNext(){
        if (done || page > MAX_PAGES) { finish(); return; }
        var url = '/collections/' + COLLECTION_HANDLE + '?page=' + page + '&_cb=' + Date.now();
        page++;
        /* 2026-08-14 (250-cap fix): browsers default the Accept header to the wildcard value on
           fetch(); Shopify storefront answers XHR requests without an HTML Accept with a JSON
           404 — so the bare XHR header made every page-2 fetch fail silently (the append path
           was never exercisable in production). Send an explicit HTML Accept + X-Requested-With. */
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8' } })
          .then(function(r){ return r.text(); })
          .then(function(html){
            var m = html.match(/<script type="application\/json" id="plk-map-pins">([\s\S]*?)<\/script>/);
            var raw = m ? (JSON.parse(m[1]) || []) : [];
            var more = filterPins(raw);   /* Phase 2: belt-and-braces children filter. */
            var added = 0;
            more.forEach(function(p){
              if (p && p.handle && !seen[p.handle]) {
                seen[p.handle] = true;
                PINS.push(p);
                added++;
              }
            });
            if (added) usable = true;
            /* Short page (<250 raw) = last page; a full 250-raw page that added nothing = stale
               duplicate-served page (cache-blind) — stop in both cases, never loop forever. */
            done = (raw.length < 250) || (added === 0);
            if (!done) { fetchNext(); return; }
            finish();
          })
          .catch(function(e){
            if (window.console) console.warn('[plk-map] page fetch failed:', e);
            finish();
          });
      }
      fetchNext();
    }

    /* ---------- "Search this area" chip (shows when viewport moved since last commit) ---------- */
    var searchBtn = document.querySelector('[data-plk-searcharea]');
    function boundsChanged(a, b){
      if(!a||!b) return true;
      return Math.abs(a.getWest()-b.getWest())>0.001 || Math.abs(a.getEast()-b.getEast())>0.001 || Math.abs(a.getNorth()-b.getNorth())>0.001 || Math.abs(a.getSouth()-b.getSouth())>0.001;
    }
    function maybeShowSearchArea(){
      if(!map || !searchBtn) return;
      var b = map.getBounds();
      var moved = !lastCommittedBounds || boundsChanged(lastCommittedBounds, b);
      searchBtn.setAttribute('data-show', moved ? 'true' : 'false');
    }
    /* Phase 3: the searcharea commit is also the city-label click action — extracted so both paths
       share one implementation. */
    function commitSearchArea(b){
      if(!map) return;
      framing = false; areaFilter = b || map.getBounds(); lastCommittedBounds = areaFilter;
      buildRegionOptions();   /* Phase 2d: region counts follow the committed viewport */
      setListType('properties'); resetListScroll(); refreshSource(); applyGate(); if(searchBtn) searchBtn.setAttribute('data-show','false');
    }
    if(searchBtn){ searchBtn.addEventListener('click', function(){ commitSearchArea(); }); }

    /* ---------- deep-link #z/lat/lon camera hash ---------- */
    function parseHashCamera(){
      var h = location.hash || '';
      if(h.charAt(0)==='#') h = h.slice(1);
      var parts = h.split('/');
      if(parts.length === 3){
        var z = parseFloat(parts[0]), lat = parseFloat(parts[1]), lon = parseFloat(parts[2]);
        if(isFinite(z) && isFinite(lat) && isFinite(lon)) return { zoom: z, center: [lon, lat] };
      }
      return null;
    }
    function writeHash(){
      if(!map) return;
      var c = map.getCenter();
      try { history.replaceState(null,'', '#'+round(map.getZoom(),2)+'/'+round(c.lat,4)+'/'+round(c.lng,4)); } catch(e){}
    }

    /* ---------- framing (E9 geographic bbox; fallback pin-bbox) ---------- */
    function frameGeographic(cb){
      if(!map) { cb(false); return; }
      if(FRAME_KIND === 'country'){
        var iso3 = nameIndex[norm(COLLECTION_TITLE)];
        var feat = iso3 ? featByIso3[iso3] : null;
        if(feat){ var b = fcBbox(feat); if(b){ fitBbox(b, padFrame()); cb(true); return; } }
        cb(false);
      } else if(FRAME_KIND === 'region'){
        if(!COUNTRY_HANDLE){ cb(false); return; }
        fetch(MAPS_BASE + '/' + COUNTRY_HANDLE + '.geojson').then(function(r){ if(!r.ok) throw 0; return r.json(); }).then(function(fc){
          var feats = fc.features || [];
          var match = feats.filter(function(f){ var p=f.properties||{}; return p.handle === COLLECTION_HANDLE || p.slug === COLLECTION_HANDLE; })[0];
          var feat = match || feats[0];
          var b = feat ? fcBbox(feat) : (fc.bbox ? fc.bbox : null);
          if(b){ fitBbox(b, padFrame()); cb(true); } else { cb(false); }
        }).catch(function(){ cb(false); });
      } else { cb(false); }
    }
    function frameToPins(){
      if(!map || !PINS.length || !window.maplibregl) return false;
      try {
        var bounds = PINS.reduce(function(b,p){ return b.extend([p.lon,p.lat]); }, new window.maplibregl.LngLatBounds());
        map.fitBounds(bounds, { padding: padFrame(), maxZoom: 8 });
        return true;
      } catch(e){ return false; }
    }
    function frameAfrica(){
      if(!map || !window.maplibregl) return;
      try {
        var iw = window.innerWidth, ih = window.innerHeight;
        var pad;
        if (iw <= 768) {
          pad = { top: 90, bottom: 40, left: Math.min(60, Math.round(iw * 0.08)), right: 40 };
        } else {
          pad = { top: 90, bottom: 40, left: Math.min(120, Math.round(iw * 0.1)), right: 40 };
        }
        map.fitBounds([[-20, -38], [52, 38]], { padding: pad, linear: false });
      } catch(e){}
    }
    function afterFrame(){
      applyGate();
      rebuildBasePins();   /* Phase 2: build the initial spatial index over parent-only pins. */
      buildChips();
      var isDrill = (FRAME_KIND === 'country' || FRAME_KIND === 'region');
      setSatellite(true);   /* Africa-focus: satellite on for ALL views (world=Africa + country/region) */
      setCountryHighlight(isDrill ? activeCountryIso3 : '');
      var dl = categoryFromUrl();
      if (dl && MAP_VIEW === 'collection' && !activeChip){ var def=null; for (var i=0;i<CHIP_DEFS.length;i++){ if (CHIP_DEFS[i].label.toLowerCase() === String(dl).toLowerCase()){ def=CHIP_DEFS[i]; break; } } if (def){ selectChip(def.label); return; } }
      /* Phase 2d: honor ?region= and ?sort= deep-links (client-side; region drops out if the pins
         no longer carry that region). run after buildChips so the region <select> has its options.
         Phase 2e: ?sort_by= (native param — the bake order is unchanged server-side, so the value
         TRANSLATES to the equivalent client sort; see the SORTBY_TO_MODE table on the change
         handler). Legacy client ?sort= (featured|az|region) takes precedence when both are present. */
      if (MAP_VIEW === 'collection'){
        var _rn = regionNameFromUrl();
        if (_rn) { selectRegion(_rn); } else if (regionSelect) { regionSelect.value = activeRegion || ''; }
        var _sb = sortByFromUrl();
        var _sm = sortFromUrl();
        if (_sm) { applySort(_sm); }
        else if (_sb) { applySort(SORTBY_TO_MODE[_sb] || 'featured'); }
        else if (sortSelect) { sortSelect.value = sortMode; }
      }
      if (MAP_VIEW === 'world'){ renderWorldCrumb(); return; }   /* world: panel hidden via CSS; browse path = search dropdown */
      /* doc 106: country/region default to Destinations (a ?category= property deep-link already
         returned above; honor ?list=properties). Fall back to Properties if no ≥2-pin destinations.
         T5 Phase C: card tiers (country/region/tourism_area) default to the destinations tab unless
         the user opted out via ?list=properties or the tier is FEATURED (single-property place
         view). autoDestDefault tracks that the choice was hierarchy-driven, so the data-landing
         code can fall back to property rows when a tier turns out to have no children. */
      var explicitDest = (listTypeFromUrl() === 'destinations');
      autoDestDefault = !explicitDest && !FEATURED && MAP_VIEW === 'collection' && tierCards();
      var startList = (explicitDest || autoDestDefault) ? 'destinations' : 'properties';
      if (startList === 'destinations' && !ensureDests().length){ startList = 'properties'; autoDestDefault = false; }
      setListType(startList, { silent:true });
      renderPanelCrumb();
      loadMorePages(); /* append pages 2+ once the initial list is rendered */
      if (focusHandle){ ensureDests(); if(destBySlug[focusHandle]){ selectDestination(focusHandle, { silent:true }); } }   /* &focus=<dest-slug> deep-link */
    }
    function commitFrame(){ framing = false; lastCommittedBounds = map ? map.getBounds() : null; if(searchBtn) searchBtn.setAttribute('data-show','false'); if(moveTimer) clearTimeout(moveTimer); moveTimer = setTimeout(writeHash, 300); }
    function doFrame(opts){
      opts = opts || {};
      framing = true;
      setTimeout(function(){ if(framing) commitFrame(); }, 1200);   /* safety clear if no moveend fires (e.g. jumpTo to the same center) */
      var hashCam = (!opts.force) ? parseHashCamera() : null;
      if(hashCam){
        try { map.jumpTo(hashCam); } catch(e){}
        afterFrame();
        if(focusPin && ZOOM_REGION){ framing = true; try { map.jumpTo({ center:[focusPin.lon, focusPin.lat], zoom: REGION_FOCUS_ZOOM }); } catch(e){} }   /* URL contract zoom=region: area framing, no detail card */
        else if(focusPin){ framing = true; selectPin(focusPin.handle, {silent:true}); }   /* re-arm so the easeTo moveend commits cleanly (no chip flicker) */
        return;
      }
      if(focusPin && !opts.ignoreFocus){ afterFrame(); if(ZOOM_REGION){ try { map.jumpTo({ center:[focusPin.lon, focusPin.lat], zoom: REGION_FOCUS_ZOOM }); } catch(e){} } else { selectPin(focusPin.handle, {silent:true}); } return; }   /* zoom=region: area framing, no detail card (URL contract v1) */
      /* 3c: dest-slug focus (?focus=<town-slug>) — skip the country/region frameGeographic (and its
         ~1-3s countries.geojson fetch + country fitBounds) so the map goes straight to the destination
         centroid. afterFrame() runs selectDestination(focusHandle) which eases to the area centroid +
         opens the destination card. Product handles (focusPin) are handled above; buildDestinations
         drops areas that equal a property title, so a dest slug never collides with a product handle.
         Country outline/highlight is safe — activeCountryIso3 is set by bindCountries, not frameGeographic. */
      if (focusHandle){ ensureDests(); if (destBySlug[focusHandle]){ afterFrame(); return; } }
      if (FRAME_KIND === 'world'){ frameAfrica(); afterFrame(); return; }
      frameGeographic(function(ok){ if(!ok) frameToPins(); afterFrame(); });
    }

    /* ===== doc 106: Destinations layer (country/region). Derived ONLY from the live PINS —
       no DB/app dependency (curated Google-Place structure is a fast-follow once the scrape/
       match settles). A destination = pins grouped by a NORMALIZED `area`, with a centroid
       (average of member coords), a property count, top properties (flagship-first), and a
       thumbnail (top property image). Areas that equal a property title, or that gather <2
       pins, are dropped (misattributed property names + single-pin noise — those stays remain
       on the map and in the Properties tab). Coordinates come from the live pins (ultimately
       Google-sourced downstream), NEVER from wetu. ===== */
    var listType = 'properties';   /* 'destinations' | 'properties' — set by setListType() in afterFrame */
    /* T5 Phase C: startList was hierarchy-driven (re-evaluated in afterFrame; the declaration-time
       value covers the race where destinations.json lands before framing completes). */
    var autoDestDefault = (listTypeFromUrl() !== 'destinations') && !FEATURED && MAP_VIEW === 'collection' && tierCards();
    var listTabsEl = document.querySelector('[data-plk-listtabs]');
    /* Phase 5: embedded-mode destinations list (plk-embedded-list) removed with the retired
       plk-travel-embedded body class. Mapmode renders destinations directly in the left panel. */
    /* Known area-name fragments folded to a canonical destination (seeded from the live SA data;
       grows as needed). The curated structure will replace this normalization entirely. */
    var DEST_SYNONYMS = {
      'kruger':'Kruger National Park','kruger park':'Kruger National Park','greater kruger':'Kruger National Park','kruger park south':'Kruger National Park',
      'sabi sand':'Sabi Sands','sabi sands':'Sabi Sands','sabi sand game reserve':'Sabi Sands',
      'gqebergha':'Gqeberha','gqeberha':'Gqeberha','port elizabeth':'Gqeberha',
      'cape winelands':'Cape Winelands','winelands':'Cape Winelands'
    };
    function destSlug(name){ return String(name==null?'':name).toLowerCase().trim().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
    function destNorm(raw){ var s = String(raw==null?'':raw).trim().replace(/\s+/g,' '); if(!s) return ''; var k = s.toLowerCase(); return DEST_SYNONYMS[k] || s; }
    function buildDestinations(pins){
      pins = pins || PINS;
      var titleSet = {}; pins.forEach(function(p){ if(p && p.title) titleSet[norm(p.title)] = true; });
      var groups = {}, order = [];
      pins.forEach(function(p){
        if(!p || p.lat==null || p.lon==null) return;
        var nm = destNorm(p.area);
        if(!nm) return;
        if(titleSet[norm(nm)]) return;                                  /* area is really a property name -> drop */
        if(!groups[nm]){ groups[nm] = { name:nm, slug:destSlug(nm), pins:[], latSum:0, lonSum:0, region:'', image:'' }; order.push(nm); }
        var g = groups[nm]; g.pins.push(p); g.latSum += Number(p.lat)||0; g.lonSum += Number(p.lon)||0;
        if(!g.region && p.region) g.region = p.region;
      });
      var dests = [];
      order.forEach(function(nm){
        var g = groups[nm];
        if(g.pins.length < 2) return;                                   /* drop single-pin noise */
        g.pins.sort(function(a,b){ return (Number(b.flagshipScore)||0) - (Number(a.flagshipScore)||0); });
        g.lat = g.latSum / g.pins.length; g.lon = g.lonSum / g.pins.length;
        g.count = g.pins.length;
        for(var i=0;i<g.pins.length;i++){ if(g.pins[i].image){ g.image = g.pins[i].image; break; } }
        dests.push(g);
      });
      dests.sort(function(a,b){ return b.count - a.count; });
      return dests;
    }
    var DESTS = [], destBySlug = {}, childrenBySlug = {};
    function rebuildDests(){
      if (!GLOBAL_DESTS) return;
      var slug = currentSlug();
      if (!slug) { DESTS = []; destBySlug = {}; childrenBySlug = {}; return; }
      var countryData = null;
      Object.keys(GLOBAL_DESTS).forEach(function(iso){
        var c = GLOBAL_DESTS[iso];
        if (c && c.country && c.country.slug === slug) { countryData = c; }
        (c.destinations || []).forEach(function(d){ if (d && d.slug === slug && d.parent_slug) { countryData = c; } });
      });
      if (!countryData || !countryData.destinations) { DESTS = []; destBySlug = {}; childrenBySlug = {}; return; }
      var all = countryData.destinations;
      DESTS = all.filter(function(d){ return d.parent_slug === slug; }).map(function(d){
        return {
          name: d.name, slug: d.slug, lat: d.lat, lon: d.lng,
          count: d.place_count, level: d.level, top_properties: d.top_properties || [],
          copy: d.copy || null,
          google_place_id: d.google_place_id || '',   /* T5 D: carried so destCoverSrc() can proxy — the popup hero would otherwise fall back to the Shopify thumb for every child dest */
          image: d.image || '',
          parent_slug: d.parent_slug, viewport: d.viewport
        };
      });
      destBySlug = {};
      childrenBySlug = {};
      DESTS.forEach(function(d){ destBySlug[d.slug] = d; });
      all.forEach(function(d){
        if (!d || !d.parent_slug) return;
        if (!childrenBySlug[d.parent_slug]) childrenBySlug[d.parent_slug] = [];
        childrenBySlug[d.parent_slug].push(d);
      });
      /* If the destinations tab is already active, re-render so the newly loaded data appears. */
      if (listType === 'destinations') renderRows();
    }
    function ensureDests(){
      if (!DESTS.length) {
        if (GLOBAL_DESTS) rebuildDests();
        else if (PINS.length) {
          DESTS = buildDestinations(PINS);
          destBySlug = {}; childrenBySlug = {};
          DESTS.forEach(function(d){ destBySlug[d.slug] = d; });
        }
      }
      return DESTS;
    }
    function destsToFeatures(list){ return { type:'FeatureCollection', features: (list||[]).map(function(d){ return { type:'Feature', geometry:{type:'Point',coordinates:[d.lon,d.lat]}, properties:{ slug:d.slug, name:d.name, count:d.count } }; }) }; }
    function refreshDestSource(){
      if (!(map && map.getSource('destinations'))) return;
      try { map.getSource('destinations').setData(destsToFeatures(ensureDests())); } catch(e){}
    }

    function listTypeFromUrl(){ try { return new URL(location.href).searchParams.get('list'); } catch(e){ return null; } }
    function setListTypeUrl(t){ try { var u = new URL(location.href); if(t==='properties') u.searchParams.set('list','properties'); else u.searchParams.delete('list'); history.replaceState(null,'',u.href); } catch(e){} }

    function setListType(t, opts){
      opts = opts || {};
      if (t !== 'destinations' && t !== 'properties') return;
      /* Phase 2f guard: the destinations layer must exist and have data before we switch, otherwise
         applyListType would hide property pins and show nothing -> blank map. */
      if (t === 'destinations'){
        if (!ensureDests().length) return;
        if (!map || !map.getLayer('dest-markers')) return;
      }
      /* T5 Phase E: card-type switch = activate the OTHER live container BEFORE rendering. Both
         lists stay rendered with their scrollTop intact across the switch. */
      if (destRowsEl && t !== listType){
        if (t === 'destinations'){
          activateRows(destRowsEl);
          if (needsDestRender()) renderDestinations(destRowsEl);
          else {   /* scroll-preserved switch: DOM is already live — just re-fix the panel head */
            var _ct = panel ? panel.querySelector('[data-plk-count]') : null;
            var _tt = panel ? panel.querySelector('[data-plk-title]') : null;
            if (_tt){ _tt.textContent = (COLLECTION_TITLE || 'Destinations'); }
            if (_ct){ _ct.textContent = DESTS.length + ' destination' + (DESTS.length === 1 ? '' : 's'); }
          }
        } else {
          activateRows(propsRowsEl);
        }
      }
      listType = t;
      if(listTabsEl){ listTabsEl.querySelectorAll('.plk-listtab').forEach(function(b){ b.setAttribute('data-active', b.getAttribute('data-listtab')===t ? 'true' : 'false'); }); }
      try { document.body.setAttribute('data-plk-list', t); } catch(e){}
      if(chipsEl){ chipsEl.hidden = !(t === 'properties'); }                       /* chips are property-category filters */
      if(panel){ if(t==='properties' && chipsEl && !chipsEl.hidden && chipsEl.childNodes.length) panel.classList.add('plk-panel--withchips'); else panel.classList.remove('plk-panel--withchips'); }
      setMode('results');
      renderRows();
      renderPanelCrumb();
      applyListType();
      if(!opts.silent) setListTypeUrl(t);
    }
    function renderRows(){
      if (listType === 'destinations') {
        /* T5 Phase E: re-render only when the data changed — otherwise the preserved scrollTop
           (and the live DOM) survive the card-type switch. */
        if (needsDestRender()) renderDestinations(destRowsEl || rowsEl);
      } else {
        /* Phase 2: prefer virtualized list; fall back to Phase 1 scroll-append if virtualizer cannot init. */
        renderVirtualList();
        if (!virtualizer) { renderList(); }
      }
    }

    /* T5 Phase C hard rule: never serve a raw Google photo URL (they embed the API key). Current
       data is Shopify-CDN-only; the guard makes the rule hold at the render surface forever. */
    function destThumbnail(d){ var u = d.image || (d.top_properties && d.top_properties[0] && d.top_properties[0].image) || ''; return (u && u.indexOf('googleusercontent.com') > -1) ? '' : u; }
    /* T5 Phase D: cover source. Destinations with a google_place_id route through the app's
       cover-proxy (/api/covers/:gid) which dereferences places.photos server-side and streams the
       image WITHOUT the API key. No photo row -> proxy 404 -> the [data-fb] onerror swaps to
       destThumbnail (top-property Shopify CDN). 0 raw google URLs at the render surface. */
    function destCoverSrc(d){
      if (d && d.google_place_id) return 'https://app.plekify.com/api/covers/' + encodeURIComponent(d.google_place_id) + '?w=800';
      return destThumbnail(d);
    }
    /* T5 Phase D: "Open destination" round-trips the current ?view=map/?view=list (phase 3b
       canonical unprefixed /collections/<slug>); everything else (focus, chips) is dropped. */
    function destUrlFor(slug){
      try {
        var v = new URL(location.href).searchParams.get('view');
        return '/collections/' + slug + ((v === 'map' || v === 'list') ? '?view=' + v : '');
      } catch(e){ return '/collections/' + slug; }
    }
    /* T5 Phase E: hover a place-card / property row -> pulse its marker AND ease the map to it.
       mouseenter-only (never focus/blur) so scanning the list doesn't fire per-pixel; MapLibre
       supersedes in-flight eases, so a fast sweep cannot queue animations. */
    function hoverEaseTo(lon, lat){
      if (!map) return;
      try { map.easeTo({ center: [lon, lat], zoom: Math.max(map.getZoom(), 6), offset: panOffset(), duration: 600 }); } catch(e){}
    }
    function copyRow(label, val){
      return (val && String(val).trim())
        ? '<div class="plk-destcard__field"><div class="plk-destcard__flabel">'+esc(label)+'</div><p class="plk-destcard__ftext">'+esc(val)+'</p></div>'
        : '';
    }
    /* T5 Phase C: N stays for a child destination = live-gated pins (the bake IS the
       copy.eligibility=='live' gate) whose country/region/sub-handle facet matches its slug.
       Facets are prefixed-stripped where the section bake could not unprefix; 0 = omit (fail-closed). */
    function normHandle(h){ return String(h || '').replace(/^(country|region|city|tourism-area|tourism_area|area|suburb)-/, ''); }
    function staysFor(slug){
      if (!PINS.length) return 0;
      var n = 0;
      for (var i = 0; i < PINS.length; i++){
        var p = PINS[i];
        if (normHandle(p.subHandle) === slug || normHandle(p.regionHandle) === slug || normHandle(p.countryHandle) === slug) n++;
      }
      return n;
    }
    function destMeta(d){
      var meta = ['<span class="plk-row__pincount">'+d.count+' stay'+(d.count===1?'':'s')+'</span>'];
      if (d.level) meta.push(esc(d.level));
      else if (d.region && norm(d.region) !== norm(d.name)) meta.push(esc(d.region));
      else if (d.pins && d.pins[0] && d.pins[0].country) meta.push(esc(d.pins[0].country));
      return meta;
    }
    /* T5 Phase E: destinations ALWAYS render into their own container (data-plk-rows-standby in
       the markup; the attribute swaps with data-plk-rows when the mode activates). This lets the
       card-type switch keep BOTH lists alive — the off-screen one stays rendered with its scrollTop
       intact, so switching back never re-renders from zero. */
    var destRowsEl = panel ? panel.querySelector('[data-plk-rows-standby]') : null;
    var propsRowsEl = rowsEl;   /* the properties/virtualized container (first rows div in the markup) */
    var destRenderKey = '';
    function destKeyNow(){ return DESTS.length + '|' + (DESTS[0] ? DESTS[0].slug : '') + '|' + (DESTS[DESTS.length-1] ? DESTS[DESTS.length-1].slug : ''); }
    function needsDestRender(){ return destRenderKey !== destKeyNow() || (destRowsEl && !destRowsEl.childElementCount); }
    /* T5 Phase E: swap which of the two list containers is ON-screen. The other goes off-screen
       (translateX(-100%) CSS + inert) WITHOUT losing its DOM or scrollTop — the mandated
       preservation mechanism, never display:none. The attributes move so every existing
       [data-plk-rows] selector keeps resolving to the active container. */
    function activateRows(a){
      if (!panel || !a) return;
      var cur = panel.querySelector('[data-plk-rows]');
      if (cur === a) return;
      var old = panel.querySelector('[data-plk-rows-standby]');
      if (cur){ cur.removeAttribute('data-plk-rows'); cur.setAttribute('data-plk-rows-standby',''); cur.setAttribute('inert',''); cur.setAttribute('aria-hidden','true'); }
      if (old && old !== a){ old.removeAttribute('data-plk-rows-standby'); }
      a.removeAttribute('data-plk-rows-standby'); a.setAttribute('data-plk-rows',''); a.removeAttribute('inert'); a.removeAttribute('aria-hidden');
      rowsEl = a;
      /* Phase 2d gotcha: setOptions() REPLACES the option object — re-state the full set so the
         virtualizer rebinds its scroll element to the now-active properties container. */
      if (virtualizer && a === propsRowsEl){
        try { virtualizer.setOptions(virtualizerOptsFor(effectivePins().length)); } catch(e){}
      }
    }
    function renderDestinations(rowsEl, countEl, titleEl){
      ensureDests();
      rowsEl = rowsEl || destRowsEl || (panel ? panel.querySelector('[data-plk-rows]') : null);
      countEl = countEl || (panel ? panel.querySelector('[data-plk-count]') : null);
      titleEl = titleEl || (panel ? panel.querySelector('[data-plk-title]') : null);
      if (!rowsEl) return;
      if(titleEl){ titleEl.textContent = (COLLECTION_TITLE || 'Destinations'); }
      if(clearBtn){ clearBtn.hidden = true; }   /* chips/filters are property-only; hide in destinations mode */
      if(!DESTS.length){
        rowsEl.innerHTML = '<div class="plk-panel__empty">No destinations found in this area yet. <button class="plk-panel__clear" data-plk-show-props type="button" style="display:inline;margin:0;padding:0;color:#15171a;text-decoration:underline;background:transparent">Browse properties</button></div>';
        var sb = rowsEl.querySelector('[data-plk-show-props]'); if(sb) sb.addEventListener('click', function(){ setListType('properties'); });
        if(countEl){ countEl.textContent = ''; }
        return;
      }
      /* T5 Phase C: card-type by tier (the country==region fix). Card tiers (country/region/
         tourism_area) compose each child destination as a PLACE-CARD — cover (Shopify CDN via
         top_properties, never a raw Google URL), name, tagline (dest.copy.tagline — omit if
         absent), N live stays (pin facets — omit if no facet matches) and M sub-regions
         (childrenBySlug — omit if none). Leaf tiers (city/suburb) keep property rows and this
         function renders the plain row composition. All gaps fail closed: omit, never fabricate. */
      var placeMode = !FEATURED && MAP_VIEW === 'collection' && tierCards();
      var html = '';
      DESTS.forEach(function(d){
        var meta = destMeta(d);
        var _cov = destCoverSrc(d); var _fb = destThumbnail(d);
        var media = _cov ? '<img class="plk-row__thumb" src="'+esc(_cov)+'" alt="" loading="lazy"' + (_fb ? ' data-fb="'+esc(_fb)+'"' : '') + '>' : '<div class="plk-row__ph">&#x1F4CD;</div>';
        if (placeMode){
          var nStay = staysFor(d.slug);
          var mKids = (childrenBySlug[d.slug] || []).length;
          var meta2 = [];
          if (nStay > 0) meta2.push(nStay + ' stay' + (nStay === 1 ? '' : 's'));
          if (mKids > 0) meta2.push(mKids + ' place' + (mKids === 1 ? '' : 's') + ' within');
          if (d.level) meta2.push(esc(d.level));
          var tagline = (d.copy && d.copy.tagline) ? '<span class="plk-row__tagline">'+esc(d.copy.tagline)+'</span>' : '';
          html += '<button class="plk-row plk-row--place" type="button" data-dest="'+cssEsc(d.slug)+'" data-lat="'+d.lat+'" data-lon="'+d.lon+'">'
            + '<span class="plk-row__media">'+media+'</span>'
            + '<span class="plk-row__body"><span class="plk-row__title">'+esc(d.name)+'</span>'
            + tagline
            + (meta2.length ? '<span class="plk-row__meta">'+meta2.join(' &middot; ')+'</span>' : '')
            + '</span></button>';
          return;
        }
        html += '<button class="plk-row" type="button" data-dest="'+cssEsc(d.slug)+'" data-lat="'+d.lat+'" data-lon="'+d.lon+'">'
          + '<span class="plk-row__media">'+media+'</span>'
          + '<span class="plk-row__body"><span class="plk-row__title">'+esc(d.name)+'</span>'
          + '<span class="plk-row__meta">'+meta.join(' &middot; ')+'</span></span></button>';
      });
      rowsEl.innerHTML = html;
      if(countEl){ countEl.textContent = DESTS.length + ' destination' + (DESTS.length===1?'':'s'); }
      rowsEl.querySelectorAll('.plk-row__thumb[data-fb]').forEach(function(im){   /* proxy 404 -> Shopify-CDN stand-in */
        im.addEventListener('error', function(){ this.onerror = null; var fb = this.getAttribute('data-fb'); if (fb && this.src.indexOf(fb) === -1) this.src = fb; });
      });
      rowsEl.querySelectorAll('.plk-row[data-dest]').forEach(function(row){
        var slug = row.getAttribute('data-dest');
        row.addEventListener('click', function(){ selectDestination(slug); });
        /* T5 Phase E: pulse + ease on hover (row-hover -> pin coupling, the NEW half). */
        row.addEventListener('mouseenter', function(){ var d = destBySlug[slug]; if(d && map){ highlightDestMarker(d, true); hoverEaseTo(d.lon, d.lat); } });
        row.addEventListener('mouseleave', function(){ highlightDestMarker(null, false); });
        row.addEventListener('focus', function(){ var d = destBySlug[slug]; if(d && map) highlightDestMarker(d, true); });
        row.addEventListener('blur', function(){ highlightDestMarker(null, false); });
      });
      destRenderKey = destKeyNow();
    }

    /* destination map layer + rows↔markers sync */
    function applyListType(){
      if(!map) return;
      var dest = (listType === 'destinations');
      try { map.setLayoutProperty('dest-markers','visibility', dest ? 'visible' : 'none'); } catch(e){}
      if(dest){ ['pin-unclustered'].forEach(function(id){ try { map.setLayoutProperty(id,'visibility','none'); } catch(e){} }); }
      else { applyGate(); }   /* restore the zoom/show-pins gate for property pins */
    }
    var destHoverMarker = null, destSelectedMarker = null;
    function highlightDestMarker(d, on){
      if(!map || !window.maplibregl) return;
      if(destHoverMarker){ try { destHoverMarker.remove(); } catch(e){} destHoverMarker = null; }
      if(on && d){ try { var el = document.createElement('div'); el.className = 'plk-pin-hover'; destHoverMarker = new window.maplibregl.Marker({element:el, anchor:'center', tabIndex:-1}).setLngLat([d.lon, d.lat]).addTo(map); } catch(e){} }
    }
    function setSelectedDestination(d){
      if(destSelectedMarker){ try { destSelectedMarker.remove(); } catch(e){} destSelectedMarker = null; }
      if(!map || !window.maplibregl || !d) return;
      try { var el = document.createElement('div'); el.className = 'plk-dest-ring'; destSelectedMarker = new window.maplibregl.Marker({element:el, anchor:'center', tabIndex:-1}).setLngLat([d.lon, d.lat]).addTo(map); } catch(e){}
    }
    function selectDestination(slug, opts){
      opts = opts || {};
      ensureDests();
      var d = destBySlug[slug];
      if(!d) return;
      clearSelected();                       /* clears property ring/popup AND any destination ring */
      setSelectedDestination(d);
      openDestinationCard(d);
      if (panel){
        var row = panel.querySelector('.plk-row[data-dest="'+cssEsc(slug)+'"]');
        if(row){ panel.querySelectorAll('.plk-row').forEach(function(r){ r.classList.remove('plk-row--active'); }); row.classList.add('plk-row--active'); row.scrollIntoView({ block:'nearest', behavior:'smooth' }); }
      }
      if(map){ try { map.easeTo({ center:[d.lon, d.lat], zoom: Math.max(map.getZoom(), 8), offset: panOffset(), duration: 500 }); } catch(e){} }
      if(!opts.silent){ setFocusUrl(slug); }
    }

    /* Phase 2a: destination card — built ONLY from destinations.json fields (name, place_count,
       top_properties, children). No product probe, no generated prose, no WETU Tier-A. The new-tab
       icon always points to /collections/<slug> (Phase 3 creates the collections; link regardless). */
    function openDestinationCard(d){
      if(!sheetEl || !sheetContent) return;
      var root = document.querySelector('[data-plk-mapmode]');
      if(root){ root.setAttribute('data-sheet-open','true'); }
      sheetOpen = true;                      /* set now so mapLeftEdge()/panOffset() pre-center for the sheet */
      if(sheetOpenBtn){ sheetOpenBtn.setAttribute('href', destUrlFor(d.slug)); }   /* new-tab icon -> destination collection, ?view round-trip */
      sheetContent.classList.remove('plk-sheet__content--ready');
      sheetContent.innerHTML = '';
      if(sheetBody){ sheetBody.scrollTop = 0; }
      if(sheetLoadTimer){ clearTimeout(sheetLoadTimer); sheetLoadTimer = null; }
      renderDestinationGeneratedCard(d);
    }
    /* T5 Phase D: Google-Maps-style destination detail card. 5-tab nav (Overview / Stays /
       Activities / Seasonality / Access); the 3 data-less tabs are DISABLED with a "Coming soon"
       affordance — platform richness signalling, no fabricated/broken empty panes. Overview renders
       the 6 dest.copy fields fail-closed (omit absent, never fabricate) and hides entirely at zero
       copy; Stays always renders the top-properties grid. Ratings: OMIT (1/321 dests rated today).
       Actions: Save = localStorage bookmark (ponytail: backend persistence when user-accounts
       land); Share = navigator.share with clipboard fallback (ponytail: no share-analytics or
       image assets yet); Open destination = real CTA -> /collections/<slug> (unprefixed canonical)
       with ?view=map/?view=list round-tripped. */
    function renderDestinationGeneratedCard(d){
      if(!sheetContent) return;
      var top = d.top_properties || (d.pins ? d.pins.slice(0, 6) : []);
      var cp = d.copy || null;
      var openUrl = destUrlFor(d.slug);

      /* Overview pane: the 6 dest.copy fields, each omitted when absent (fail-closed). */
      var ovHtml = '';
      if (cp){
        if (cp.tagline) ovHtml += '<p class="plk-destcard__tagline">'+esc(cp.tagline)+'</p>';
        ovHtml += copyRow('Overview', cp.landing_lede)
          + copyRow('Description', cp.description)
          + copyRow('In the area', cp.map_snippet)
          + copyRow('Search snippet', cp.search_snippet)
          + copyRow('Summary', cp.meta_description);
      }
      var hasOverview = ovHtml.length > 0;

      /* Hero cover: cover-proxy Google photo when the dest has a google_place_id; the onerror
         [data-fb] swap keeps the top-property Shopify image as the fail-closed stand-in. */
      var heroCover = destCoverSrc(d);
      var heroFb = destThumbnail(d);
      var hero = heroCover
        ? '<img src="'+esc(heroCover)+'" alt="'+esc(d.name)+'" data-fb="'+esc(heroFb)+'">'
        : '';
      var heroMeta = '';
      if (d.level) heroMeta = '<span class="plk-destcard__place">'+esc(String(d.level).replace(/_/g,'-'))+'</span>';

      var cards = top.map(function(p){
        var img = p.image ? '<img class="pr-related__image" src="'+esc(p.image)+'" alt="">' : '';
        var tagline = p.copyShort || '';
        return '<a class="pr-related__card" href="'+esc('/products/' + p.handle)+'" data-handle="'+cssEsc(p.handle)+'">'
          + '<div class="pr-related__media">'+img+'<div class="pr-related__overlay"><h2 class="pr-related__title">'+esc(p.title)+'</h2></div></div>'
          + '<div class="pr-related__below">'+(tagline ? '<p class="pr-related__tagline">'+esc(tagline)+'</p>' : '')+'</div></a>';
      }).join('');
      var children = childrenBySlug[d.slug] || [];
      var childHtml = '';
      if (children.length){
        childHtml = '<h3 class="plk-destcard__h">Places within '+esc(d.name)+'</h3><div class="plk-destcard__children">'
          + children.map(function(c){
              return '<button class="plk-destcard__child" type="button" data-dest="'+cssEsc(c.slug)+'">'+esc(c.name)+' <span class="plk-destcard__childcount">'+c.place_count+'</span></button>';
            }).join('')
          + '</div>';
      }

      /* 5-tab nav. Overview tab present iff there is copy (zero-copy dests hide it entirely). */
      var tabs = '';
      if (hasOverview) tabs += '<button class="plk-desttab" type="button" role="tab" data-dtab="overview" data-active="true">Overview</button>';
      tabs += '<button class="plk-desttab" type="button" role="tab" data-dtab="stays" data-active="'+(hasOverview?'false':'true')+'">Stays</button>'
        + '<button class="plk-desttab plk-desttab--off" type="button" role="tab" disabled title="Coming soon">Activities<span class="plk-desttab__soon">Coming soon</span></button>'
        + '<button class="plk-desttab plk-desttab--off" type="button" role="tab" disabled title="Coming soon">Seasonality<span class="plk-desttab__soon">Coming soon</span></button>'
        + '<button class="plk-desttab plk-desttab--off" type="button" role="tab" disabled title="Coming soon">Access<span class="plk-desttab__soon">Coming soon</span></button>';

      var saved = false;
      try { saved = localStorage.getItem('plk-saved-' + d.slug) === '1'; } catch(e){}

      var html = '<div class="plk-destcard">'
        + (hero ? '<div class="plk-destcard__hero">' + hero + '<div class="plk-destcard__heroov"><h2 class="plk-destcard__title">'+esc(d.name)+'</h2>'+heroMeta+'</div></div>' : '')
        + '<div class="plk-destcard__actions">'
        + '<button class="plk-dact'+(saved?' plk-dact--saved':'')+'" type="button" data-dact="save" data-slug="'+cssEsc(d.slug)+'" aria-pressed="'+(saved?'true':'false')+'">'+(saved?'Saved':'Save')+'</button>'
        + '<button class="plk-dact" type="button" data-dact="share" data-slug="'+cssEsc(d.slug)+'">Share</button>'
        + '<a class="plk-dact plk-dact--open" href="'+esc(openUrl)+'" data-dact="open">Open destination</a>'
        + '</div>'
        + '<div class="plk-desttabs" role="tablist" aria-label="Destination details">'+tabs+'</div>'
        + '<div class="plk-destcard__body">'
        + (hasOverview ? '<div class="plk-destpane" data-dpane="overview" data-active="true">'+ovHtml+'</div>' : '')
        + '<div class="plk-destpane" data-dpane="stays" data-active="'+(hasOverview?'false':'true')+'">'
        + '<p class="plk-destcard__count"><strong>'+d.count+' stay'+(d.count===1?'':'s')+'</strong> in this destination.</p>'
        + (top.length ? '<h3 class="plk-destcard__h">Top stays here</h3><div class="plk-destcard__grid">'+cards+'</div>' : '')
        + childHtml
        + '</div>'
        + '</div></div>';
      sheetContent.innerHTML = html;

      /* cover-proxy 404 or network fail -> Shopify-CDN stand-in, once (no error loops) */
      var heroImg = sheetContent.querySelector('.plk-destcard__hero img[data-fb]');
      if (heroImg){ heroImg.addEventListener('error', function(){ this.onerror = null; var fb = this.getAttribute('data-fb'); if (fb && this.src.indexOf(fb) === -1) this.src = fb; }); }

      /* T5 close-out (Flag A — Places TOS): Google requires the credited photographer to be
         shown near the photo. Companion endpoint to the cover-proxy; renders "Photo: <name>"
         linked to the author's public Google profile. Fail-closed: omit on fetch error or
         empty list (some photos carry no photographer credit — TOS allows omit then). */
      var attrHost = sheetContent.querySelector('.plk-destcard__hero');
      if (attrHost && d.google_place_id){
        fetch('https://app.plekify.com/api/covers/' + encodeURIComponent(d.google_place_id) + '/attribution',
              { headers: { Accept: 'application/json' } })
          .then(function(r){ if (!r.ok) throw 0; return r.json(); })
          .then(function(j){
            var list = Array.isArray(j && j.html_attributions) ? j.html_attributions : [];
            if (!list.length || !attrHost.isConnected) return;
            var items = [];
            for (var i = 0; i < list.length; i++){
              var a = list[i], o = a && typeof a === 'object' ? a : null;
              var nm = o ? String(o.displayName || '') : String(a == null ? '' : a).trim();
              if (!nm) continue;
              var u = o && o.uri ? String(o.uri) : '';
              items.push(u ? '<a href="'+esc(u)+'" target="_blank" rel="noopener noreferrer">'+esc(nm)+'</a>' : esc(nm));
            }
            if (!items.length) return;
            var aside = document.createElement('aside');
            aside.className = 'plk-cover-attr';
            aside.innerHTML = 'Photo: ' + items.join(' &middot; ');
            attrHost.appendChild(aside);
          }).catch(function(){});
      }

      sheetContent.querySelectorAll('.pr-related__card[data-handle]').forEach(function(a){
        a.addEventListener('click', function(e){ if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button!==0) return; e.preventDefault(); var h = a.getAttribute('data-handle'); if(h) selectPin(h); });
      });
      sheetContent.querySelectorAll('.plk-destcard__child[data-dest]').forEach(function(b){
        b.addEventListener('click', function(){ var slug = b.getAttribute('data-dest'); if(slug) selectDestination(slug); });
      });
      sheetContent.querySelectorAll('.plk-desttab[data-dtab]').forEach(function(b){
        b.addEventListener('click', function(){
          var k = b.getAttribute('data-dtab');
          sheetContent.querySelectorAll('.plk-desttab[data-dtab]').forEach(function(x){ x.setAttribute('data-active', x === b ? 'true' : 'false'); });
          sheetContent.querySelectorAll('.plk-destpane[data-dpane]').forEach(function(p){ p.setAttribute('data-active', p.getAttribute('data-dpane') === k ? 'true' : 'false'); });
        });
      });
      sheetContent.querySelectorAll('[data-dact="save"]').forEach(function(b){
        b.addEventListener('click', function(){
          var k = 'plk-saved-' + b.getAttribute('data-slug');
          var on = true; try { on = !(localStorage.getItem(k) === '1'); localStorage.setItem(k, on ? '1' : '0'); } catch(e){}
          b.classList.toggle('plk-dact--saved', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.textContent = on ? 'Saved' : 'Save';
        });
      });
      sheetContent.querySelectorAll('[data-dact="share"]').forEach(function(b){
        b.addEventListener('click', function(){
          var url = destUrlFor(b.getAttribute('data-slug'));
          var done = function(){ b.textContent = 'Link copied'; window.setTimeout(function(){ if (b) b.textContent = 'Share'; }, 2000); };
          if (navigator.share){ try { navigator.share({ title: document.title, url: location.origin + url }).catch(function(){}); return; } catch(e){} }
          if (navigator.clipboard){ navigator.clipboard.writeText(location.origin + url).then(done).catch(function(){ done(); }); }
          else { done(); }
        });
      });
      revealSheet();
    }
    if(listTabsEl){ listTabsEl.querySelectorAll('.plk-listtab').forEach(function(b){ b.addEventListener('click', function(){ setListType(b.getAttribute('data-listtab')); }); }); }

    function initMap(){
      if (!isWebglSupported()){ showFallback(); return; }
      if (!window.maplibregl){ showFallback(); return; }
      if (ready) return; ready = true;
      try {
        if (FEATURED){
          var fmRoot = document.querySelector('[data-plk-mapmode]');
          if (fmRoot){ fmRoot.setAttribute('data-featured','true'); }
          /* featured = place view: suppress the native grid (the embedded-mode left column). It lives
             OUTSIDE this section, hence JS not CSS. Deliberately AFTER WebGL/failed checks — a
             WebGL-less visit degrades to the normal browse page. */
          var _cw = document.querySelector('.collection-wrapper'); if (_cw) _cw.style.display = 'none';
        }
        /* Vision-2 (doc 102): optional Mapbox raster satellite source + a filtered highlight line for the active country. */
        var satLayers = [
          { id:'background', type:'background', paint:{'background-color':'#cfe3ef'} },                     /* ocean only (world view) */
          { id:'countries-fill', type:'fill', source:'countries', filter:['!=',['get','iso3'],'ATA'], paint:{
              'fill-color':['case',['==',['feature-state','hover'],true],'#bfe6c4',['==',['feature-state','live'],true],'#e9ecee','#f8fafc'],
              'fill-opacity':0 } },
          /* Vision-4 (doc 105): active-country subtle brand tint over the satellite imagery — reads
             as a "selected country" instead of a crude outline. Filtered to iso3 via
             setCountryHighlight; '__none__' = nothing highlighted (world view). */
          { id:'country-fill-hi', type:'fill', source:'countries', filter:['==',['get','iso3'],'__none__'], paint:{ 'fill-color':'#c2410c', 'fill-opacity':0 } },
          { id:'countries-line', type:'line', source:'countries', filter:['!=',['get','iso3'],'ATA'], paint:{ 'line-color':'#64748b','line-opacity':1,'line-width':1 } },
          /* Vision-4: refined political boundary = a soft white HALO (lifts the line off the imagery)
             + a thin crisp brand line. Replaces the old single 3px solid orange 'hand-drawn' line. */
          { id:'country-outline-halo', type:'line', source:'countries', filter:['==',['get','iso3'],'__none__'], paint:{ 'line-color':'#ffffff', 'line-opacity':0.7, 'line-width':5, 'line-blur':1.6 } },
          { id:'country-outline-hi', type:'line', source:'countries', filter:['==',['get','iso3'],'__none__'], paint:{ 'line-color':'#c2410c', 'line-opacity':0.95, 'line-width':1.6 } }
        ];
        var satSources = { countries: { type:'geojson', data:COUNTRIES_URL, promoteId:'iso3' } };
        if (SAT_TILES){
          satSources.satellite = { type:'raster', tiles:[SAT_TILES], tileSize:512, maxzoom:22, attribution:'© Mapbox' };
          satLayers.splice(1, 0, { id:'satellite-tiles', type:'raster', source:'satellite', layout:{visibility:'none'} });  /* below the country fill */
        }
        map = new window.maplibregl.Map({
          container: 'plk-map',
          /* Phase 3: glyphs URL added — the doc-106 "style ships no glyphs URL" note now applies only
             to legacy layers; area/city labels require this. Noto Sans via demo tile server (verified). */
          style: { version: 8, sources: satSources, layers: satLayers, glyphs: 'https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf' },
          center: [15, 12], zoom: 1.1, minZoom: 0, maxZoom: 18,
          renderWorldCopies: false,
          attributionControl: { compact: true },        /* ©Mapbox auto-shows only while the satellite layer is visible */
          cooperativeGestures: false
        });
        window._plkMap = map;

        map.on('load', function(){
          /* Phase 1: unclustered pins source. */
          map.addSource('pins', { type:'geojson', data: pinsToFeatures() });
          /* Phase 1: individual pins only — no clustering. */
          map.addLayer({ id:'pin-unclustered', type:'circle', source:'pins', paint:{
              'circle-color':'#c2410c','circle-radius':7,'circle-stroke-width':2,'circle-stroke-color':'#fff' } });

          /* Phase 2b: render per-collection pins instantly, then swap to the 955 global pins once fetched. */
          fetchGlobalPins();

          /* Phase 2a: fetch the live destination hierarchy so the Destinations tab is sourced from
             destinations.json, not the old pin-grouping. */
          fetchDestinations();

          /* doc 106: destination centroid markers (country/region Destinations mode). No symbol-label
             layer: the style ships no glyphs URL, so text would not render; the name is surfaced via
             row↔marker sync + the destination card instead. */
          map.addSource('destinations', { type:'geojson', data: destsToFeatures(ensureDests()) });
          map.addLayer({ id:'dest-markers', type:'circle', source:'destinations', layout:{ visibility:'none' }, paint:{ 'circle-color':'#15171a','circle-radius':8,'circle-stroke-width':2.5,'circle-stroke-color':'#fff','circle-stroke-opacity':0.9,'circle-opacity':0.9 } });
          map.on('click','dest-markers', function(e){ var f = e.features && e.features[0]; var slug = f && f.properties && f.properties.slug; if(slug) selectDestination(slug); });
          map.on('mousemove','dest-markers', function(){ map.getCanvas().style.cursor = 'pointer'; });
          map.on('mouseleave','dest-markers', function(){ map.getCanvas().style.cursor = ''; });

          applyGate();
          /* Phase 4-fix: provinces/areas only exist for country/region frames; keep world-frame init
             free of country-<slug>.geojson / .areas.geojson 404s. The loaders themselves also guard,
             but gating the call makes the intent explicit and avoids any unconditional path. */
          if (FRAME_KIND === 'country' || FRAME_KIND === 'region') {
            loadProvinces();
            loadAreas();
          }

          /* individual pin click -> detail */
          map.on('click','pin-unclustered', function(e){
            var f = e.features && e.features[0]; if(!f) return; var h = f.properties && f.properties.handle; if(h) selectPin(h);
          });
          map.on('mousemove','pin-unclustered', function(){ map.getCanvas().style.cursor='pointer'; });
          map.on('mouseleave','pin-unclustered', function(){ map.getCanvas().style.cursor=''; });
          /* Phase 2: bidirectional pin->list hover sync. Hovering a pin highlights the matching row and scrolls it into view. */
          map.on('mouseenter','pin-unclustered', function(e){
            var f = e.features && e.features[0]; var h = f && f.properties && f.properties.handle; if(!h) return;
            var pin = findPin(h); if(pin) showHover(pin);
            highlightRow(h);
          });
          map.on('mouseleave','pin-unclustered', function(){ clearHover(); clearHighlightRow(); });

          /* country features -> nameIndex + live highlight. doFrame MUST run AFTER bindCountries
             populates featByIso3/nameIndex, else country framing (E9) falls back to pin-bbox. */
          fetch(COUNTRIES_URL).then(function(r){ return r.json(); }).then(function(fc){
            try {
              bindCountries(fc.features || []);
              (fc.features || []).forEach(function(ft){ var pp=ft.properties||{}; if(pp.iso3 && pp.centroid){ centroidByIso3[pp.iso3]=pp.centroid; } });
            } catch(_){}
            doFrame();
          }).catch(function(){ doFrame(); });
        });

        /* country click (world view) -> that country's map */
        var downX=0, downY=0, gestureMoved=false, hoverIso3=null, centroidByIso3={};
        map.on('mousedown', function(e){ downX=e.point.x; downY=e.point.y; gestureMoved=false; });
        map.on('mousemove', function(e){ if(Math.abs(e.point.x-downX)>6 || Math.abs(e.point.y-downY)>6) gestureMoved=true; });
        map.on('mousemove','countries-fill', function(e){
          var f=e.features&&e.features[0]; var iso3=f&&f.properties&&f.properties.iso3;
          if(iso3 && handleForIso3[iso3]){
            map.getCanvas().style.cursor='pointer';
            if(hoverIso3 && hoverIso3!==iso3){ try{map.setFeatureState({source:'countries',id:hoverIso3},{hover:false});}catch(_){} }
            hoverIso3=iso3; try{map.setFeatureState({source:'countries',id:iso3},{hover:true});}catch(_){}
            var name = titleForIso3[iso3] || (f.properties && (f.properties.name_long || f.properties.name)) || '';
            if(FRAME_KIND === 'world'){
              var centroid = centroidByIso3[iso3] || (f.properties && f.properties.centroid);
              if(centroid && Array.isArray(centroid) && centroid.length >= 2 && typeof centroid[0] === 'number' && typeof centroid[1] === 'number'){
                enterCountryHover(name, centroid);
              } else {
                enterCountryHover(name, null);
              }
            } else {
              showCountryPopup(name);
            }
          } else {
            hideCountryPopup();
            leaveCountryHover();
          }
        });
        map.on('mouseleave','countries-fill', function(){ map.getCanvas().style.cursor=''; if(hoverIso3){ try{map.setFeatureState({source:'countries',id:hoverIso3},{hover:false});}catch(_){} hoverIso3=null; } hideCountryPopup(); leaveCountryHover(); });
        map.on('click','countries-fill', function(e){
          /* Phase 3: areas (z8-13) + city labels (z>=11) render above this layer — when they own
             the point, the click belongs to selectArea/commitSearchArea, not country navigation.
             doc 206 §5 D1: pins (pin-unclustered) + destination markers (dest-markers) also sit
             above — MapLibre fires handlers for EVERY layer hit at the point, so a pin click
             used to land here too and the country navigation pre-empted the detail card. */
          var own = [];
          try {
            var qLayers = ['area-fill','city-label','pin-unclustered','dest-markers'].filter(function(id){ return map.getLayer(id); });
            if (qLayers.length) own = map.queryRenderedFeatures(e.point, { layers: qLayers });
          } catch(_){}
          if (own && own.length) return;
          var f = e.features && e.features[0]; if(!f) return;
          var iso3 = f.properties && f.properties.iso3; if(!iso3) return;
          var handle = handleForIso3[iso3]; if(!handle) return;
          if(!gestureMoved){ window.location.href = '/collections/' + handle; }
        });

        /* zoom/move -> gate + search-area + hash (debounced) */
        map.on('zoom', applyGate);
        map.on('moveend', function(){
          applyGate();
          if(framing){ commitFrame(); return; }   /* end of a programmatic frame animation */
          maybeShowSearchArea();
          if(moveTimer) clearTimeout(moveTimer);
          moveTimer = setTimeout(writeHash, 300);
        });
        map.on('move', requestLeader);
        map.on('zoom', requestLeader);
        map.on('pitch', requestLeader);
        map.on('rotate', requestLeader);
        window.addEventListener('resize', requestLeader);
        window.addEventListener('scroll', requestLeader, true);

        /* control stack */
        var ctrl = document.querySelector('.plk-mapmode__controls');
        if (ctrl){
          ctrl.addEventListener('click', function(e){
            var btn = e.target.closest('.plk-ctrl'); if(!btn) return;
            var act = btn.getAttribute('data-act');
            if (act === 'zoom-in') map.zoomIn();
            else if (act === 'zoom-out') map.zoomOut();
            else if (act === 'reset'){ map.resetNorthPitch(); areaFilter=null; resetListScroll(); refreshSource(); renderRows(); doFrame({force:true, ignoreFocus:true}); }
            else if (act === 'layers'){ var v = map.getLayoutProperty('countries-line','visibility')==='none'?'visible':'none'; map.setLayoutProperty('countries-line','visibility',v); map.setLayoutProperty('countries-fill','visibility',v); btn.setAttribute('data-on', v==='visible'?'true':'false'); }
            else if (act === 'pins'){ showPins = !showPins; try{ sessionStorage.setItem(PINS_KEY, showPins?'1':'0'); }catch(_){} applyGate(); maybeShowSearchArea(); }
            else if (act === 'exit'){ window.location.href = (MAP_VIEW === 'world') ? '/collections/travel' : ('/collections/' + COLLECTION_HANDLE); }
          });
        }

        /* panel: back-to-list + grip (mobile expand) + Esc */
        if(panel){
          var back = panel.querySelector('[data-plk-back]'); if(back) back.addEventListener('click', closeDetail);
          var grip = panel.querySelector('[data-plk-grip]');
          if(grip){ grip.addEventListener('click', function(){
            /* E10 mobile: cycle peek -> expanded -> collapsed (full-screen map) -> peek */
            if(panel.classList.contains('plk-panel--collapsed')){ panel.classList.remove('plk-panel--collapsed'); }
            else if(panel.classList.contains('plk-panel--expanded')){ panel.classList.remove('plk-panel--expanded'); panel.classList.add('plk-panel--collapsed'); }
            else { panel.classList.add('plk-panel--expanded'); }
            var rp = document.querySelector('[data-plk-reopen]');
            if(rp){ rp.setAttribute('data-show', panel.classList.contains('plk-panel--collapsed') ? 'true' : 'false'); }
          }); }
          var rp = document.querySelector('[data-plk-reopen]');
          if(rp){ rp.addEventListener('click', function(){ panel.classList.remove('plk-panel--collapsed'); rp.setAttribute('data-show','false'); }); }
        }
        document.addEventListener('keydown', function(ev){ if(ev.key==='Escape' && sheetOpen) closeDetail(); });

        /* Phase 3b: wire native grid rows ↔ map pins (embedded mode). Runs once; delegation handles
           infinite-scroll-loaded rows. No-op on ?view=map (no .collection-wrapper). */
        wireNativeGrid();

      } catch(err){
        console.warn('plk map-mode init failed:', err); showFallback();
      }
    }

    function loadScript(src, cb){ var s = document.createElement('script'); s.src = src; s.onload = cb; s.onerror = cb; document.head.appendChild(s); }
    function loadCSS(href){ var l = document.createElement('link'); l.rel='stylesheet'; l.href=href; document.head.appendChild(l); }

    loadCSS(MAPLIBRE_CSS);
    /* Phase 2: load virtualizer + spatial index before MapLibre/initMap so the index is ready when the map fires. */
    loadScript(TANSTACK_VIRTUAL_CORE_JS, function(){
      loadScript(FLATBUSH_JS, function(){
        loadScript(MAPLIBRE_JS, function(){ initMap(); });
      });
    });
  })();
